// isMicroPythonMode is set on every parseEachBlock call from the Redux prop,
// so toggling the slider takes effect immediately — no page reload needed.
// Falls back to URL param on first load so the initial state is correct.
const _modeParams = new URLSearchParams(window.location.search)
let isMicroPythonMode = _modeParams.get('microPythonMode') !== 'false'

// Block delimiters — used in templates and pushed by branch().
// Python: Unicode private-use markers (indenter detects then strips them).
// C:      literal braces (indenter detects and keeps them in output).
let BLOCK_OPEN  = isMicroPythonMode ? '\ue000' : '{'
let BLOCK_CLOSE = isMicroPythonMode ? '\ue001' : '}'
// cSym returns a LAZY EVALUATOR so template strings are computed at code-gen
// time (when isMicroPythonMode reflects the current mode) rather than at
// module-load time.  The three callers in blockToCode resolve the function.
const cSym = (py, c) => () => isMicroPythonMode ? py : c

var C_imports = []
var C_code = []
var C_init = []

var procedures_codeObj = {}
var oledSensorLineCount = 0
var oledUsedLines = new Set()

//generat each block to corresponding code
function blockToCode({ blockType, params }) {
    const block = codeGenTemplates[blockType]

    if (!block) {
        throw new Error(`Unknown block type: ${blockType}`)
    }

    // Resolve cSym lazy evaluators: template values produced by cSym() are
    // functions that read isMicroPythonMode at the moment they are called,
    // so mode-switching gives the correct string without rebuilding templates.
    const resolve = (v) => (typeof v === 'function' ? v() : v)
    let imports  = resolve(block.imports)
    let initCode = resolve(block.init)
    let useCode  = resolve(block.use)

    // Replace all {{PARAM}} tokens
    for (const key in params) {
        const value = params[key]
        const token = `{{${key}}}`

        if (initCode) initCode = initCode.replaceAll(token, value)
        if (useCode) useCode = useCode.replaceAll(token, value)
    }

    // In C mode, add a semicolon to statement lines (not block openers).
    if (!isMicroPythonMode && useCode && !useCode.trim().endsWith('{')) {
        if (!useCode.trim().endsWith(';')) {
            useCode = useCode.trim() + ';'
        }
    }
    return {
        imports: imports,
        initCode: initCode?.trim(),
        useCode: useCode?.trim(),
    }
}

//remove the extenction name tht is present 1st in every block opcode
const removeDeviceName = (str) => {
    const parts = str.split('_')
    return parts.length > 1 ? parts.slice(1).join('_') : str
}
const variableNameMap = {
    'Data 1': 'data_1',
    'Data 2': 'data_2',
    'Flag 1': 'flag_1',
    'Flag 2': 'flag_2',
}

//new block code or create a new function block
//generet the code here
const proceduresToC = (
    target,
    targets,
    procedures_codeObj,
    C_imports,
    C_init,
    variables_data,
    libraryDependentFeatures
) => {
    let procedures_codeArr = []

    let current_pblock = target.next !== null ? targets[target.next] : null
    let protoType = targets[target.inputs.custom_block.block]

    let proccodeData = protoType?.mutation?.proccode
    let funcName = proccodeData?.replace(/%/g, '')?.replace(/\s+/g, '_')

    let argumentIds = JSON.parse(protoType?.mutation?.argumentids ?? '')
    // console.log('VVVVVVVVVVVV', protoType)

    let fun_arguments = []
    argumentIds.map((argumentId) => {
        var block = targets[protoType.inputs[argumentId].block]

        if (isMicroPythonMode) {
            fun_arguments.push(block.fields.VALUE.value)
        } else {
            if (block.opcode === 'argument_reporter_string_number') {
                fun_arguments.push(`char * ${block.fields.VALUE.value}`)
            } else {
                fun_arguments.push(`bool ${block.fields.VALUE.value}`)
            }
        }
    })

    const result = blockToCode({
        blockType: 'procedures_prototype',
        params: { FUN_NAME: funcName, FUN_ARGUMENTS: fun_arguments.join(', ') },
    })
    procedures_codeArr.push(result.useCode)

    if (current_pblock !== null) {
        let variables_data_copy = structuredClone(variables_data)
        branch(
            current_pblock,
            targets,
            C_imports,
            procedures_codeArr,
            C_init,
            variables_data_copy,
            libraryDependentFeatures
        )
    }

    procedures_codeArr.push(isMicroPythonMode ? `return \n\ue001` : `return;\n}`)

    procedures_codeObj[funcName] = { procedures_codeArr }
}

const extractValue = (
    targets,
    input_value_block,
    imports_array,
    code_array,
    init_array,
    value,
    variables_data,
    libraryDependentFeatures
) => {
    /* eslint-disable */console.log(...oo_oo(`3265617701_146_4_146_58_4`,'KKKKKKKKKKK', targets, input_value_block))
    if (targets[input_value_block].fields.NUM !== undefined) {
        value.push(targets[input_value_block].fields.NUM.value)
    } else if (
        targets[input_value_block].fields.VALUE !== undefined &&
        !targets[input_value_block].opcode.includes('input_digital')
    ) {
        value.push(targets[input_value_block].fields.VALUE.value)
    } else if (targets[input_value_block]?.fields?.TEXT !== undefined) {
        value.push(`"${targets[input_value_block].fields.TEXT.value}"`)
    } else if (targets[input_value_block]?.fields?.VARIABLE !== undefined) {
        value.push(
            targets[input_value_block].fields.VARIABLE.value?.replace(
                /\s+/g,
                '_'
            )
        )
    } else {
        var getValue = operator(
            targets[input_value_block],
            targets,
            imports_array,
            code_array,
            init_array,
            variables_data,
            libraryDependentFeatures
        )
        value.push(getValue)
    }
}

const getValue = (
    targets,
    current_bblock,
    imports_array,
    code_array,
    init_array,
    variables_data,
    libraryDependentFeatures
) => {
    let value = []
    // console.log('HHHHHHHHHHHHH', targets, current_bblock)

    Object.keys(current_bblock.inputs).forEach((valueKey) => {
        if (!current_bblock?.inputs?.[valueKey]?.block) {
            value.push('')
        } else {
            let input_value_block = current_bblock.inputs[valueKey].block
            extractValue(
                targets,
                input_value_block,
                imports_array,
                code_array,
                init_array,
                value,
                variables_data,
                libraryDependentFeatures
            )
        }
    })
    return value
}

//for new block create or create a function extrct the arguments
const getArguments = (
    targets,
    current_bblock,
    imports_array,
    code_array,
    init_array,
    variables_data,
    libraryDependentFeatures
) => {
    let value = []
    // console.log('HHHHHHHHHHHHH11111', targets, current_bblock)
    let argumentIds = JSON.parse(current_bblock?.mutation?.argumentids ?? '')

    argumentIds.forEach((argId) => {
        if (!current_bblock?.inputs?.[argId]?.block) {
            value.push('')
        } else {
            let input_value_block = current_bblock.inputs[argId].block
            extractValue(
                targets,
                input_value_block,
                imports_array,
                code_array,
                init_array,
                value,
                variables_data,
                libraryDependentFeatures
            )
        }
    })
    return value
}

const getSubBranch = (target, targets, notOperator) => {
    var branch
    if (notOperator === '!' || notOperator === 'not') {
        branch =
            targets[targets[target.parent].parent].inputs.SUBSTACK === undefined
                ? null
                : targets[
                      targets[targets[target.parent].parent].inputs.SUBSTACK
                          .block
                  ]
    } else {
        branch =
            targets[target.parent].inputs.SUBSTACK === undefined
                ? null
                : targets[targets[target.parent].inputs.SUBSTACK.block]
    }
    return branch
}

/**
 * Special Characters for MicroPython Code Generation
 * --------------------------------------------------
 * In MicroPython, indentation defines code blocks instead of curly braces `{}`.
 * To make Scratch-style block compilation easier, we insert two invisible
 * Unicode "Private Use Area" characters in intermediate code:
 *
 *   \ue000  → BLOCK START marker
 *   \ue001  → BLOCK END marker
 *
 * These characters NEVER appear in valid Python/MicroPython code.
 *
 * Why we use these markers:
 * -------------------------
 * 1. Helps detect where a block begins (e.g., loops, if-blocks)
 * 2. Helps detect where a block ends (equivalent of `}`)
 * 3. Allows building all lines first, then applying indentation logic later
 * 4. Prevents accidental clashes with normal Python syntax
 *
 * During final code generation:
 * -----------------------------
 * - We remove both markers from lines
 * - \ue000 increases indentation AFTER printing the line
 * - \ue001 decreases indentation BEFORE printing the next line
 *
 * Result:
 * -------
 * Properly indented MicroPython code without braces, fully compatible with Python's syntax.
 */
const condition = (
    current_block,
    targets,
    imports_array,
    code_array,
    init_array,
    variables_data,
    libraryDependentFeatures
) => {
    if (!current_block?.opcode?.includes('control')) return

    switch (current_block.opcode) {
        case 'control_forever': {
            if (Object.keys(current_block.inputs).length !== 0)
                forever(
                    targets[current_block.inputs.SUBSTACK.block],
                    targets,
                    imports_array,
                    code_array,
                    init_array,
                    variables_data,
                    libraryDependentFeatures
                )
            if (current_block.next !== null) {
            }
            break
        }
        case 'control_repeat': {
            var args =
                targets[current_block.inputs.TIMES.block].fields.NUM.value
            if (Object.keys(current_block.inputs).length !== 0)
                repeat(
                    args,
                    targets[current_block.inputs?.SUBSTACK?.block],
                    targets,
                    imports_array,
                    code_array,
                    init_array,
                    variables_data,
                    libraryDependentFeatures
                )
            break
        }
        case 'control_wait': {
            var args =
                targets[targets[current_block.id].inputs.DURATION.block].fields
                    .NUM.value
            wait(args, imports_array, code_array)
            break
        }
        case 'control_if': {
            if (current_block.inputs !== null) {
                var args = targets[current_block.inputs?.CONDITION?.block]
                if (args !== undefined) {
                    let operatorValue = operator(
                        args,
                        targets,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )

                    const result = blockToCode({
                        blockType: 'control_if',
                        params: { VALUE: `(${operatorValue})` },
                    })

                    code_array.push(`${result.useCode}`)
                    let notOperator = false
                    let subBranch = getSubBranch(args, targets, notOperator)
                    if (subBranch !== null) {
                        let variables_data_copy =
                            structuredClone(variables_data)
                        branch(
                            subBranch,
                            targets,
                            imports_array,
                            code_array,
                            init_array,
                            variables_data_copy,
                            libraryDependentFeatures
                        )
                    }

                    code_array.push(BLOCK_CLOSE)
                }
            } else {
                window.alert('No valid operator in the If or IfElse block.')
            }
            break
        }
    }
}
const inputConditions = (
    sensorC,
    targets,
    imports_array,
    code_array,
    init_array,
    variables_data,
    libraryDependentFeatures
) => {
    ////////////////// ALL INPUT  BLOCK /////////////////////////
    let currentBlockOpcode = removeDeviceName(sensorC.opcode)
    if (
        [
            'input_analog',
            'input_touchpad',
            'input_accelerometer',
            'input_gyro',
            'input_temperature',
            'input_microphone',
            'input_battery',
            'listcontents',
            'itemoflist',
            'itemnumoflist',
            'lengthoflist',
            'listcontainsitem',
            'input_ultrasonic',
            'input_ultrasonic_v2',
            'input_digital_read',
            'input_variable',
        ].includes(currentBlockOpcode)
    ) {
        let params = {}

        switch (currentBlockOpcode) {
            case 'input_analog': {
                params = {
                    PORT: sensorC.fields.PORT.value,
                    PORT_No: portMaping?.[sensorC.fields.PORT.value] ?? sensorC.fields.PORT.value,
                }
                break
            }

            case 'input_fourinone': {
                break
            }
            case 'input_touchpad': {
                params = {
                    TOUCH: sensorC.fields.PORT.value,
                    TOUCH_PIN: {'0': 10, '1': 11, '2': 12, '3': 13}[sensorC.fields.PORT.value] ?? sensorC.fields.PORT.value,
                }
                break
            }
            case 'input_accelerometer': {
                let index = 0
                if (sensorC.fields.PORT.value?.slice(-1) === 'Y') {
                    index = 1
                } else if (sensorC.fields.PORT.value?.slice(-1) === 'Z') {
                    index = 2
                }

                params = {
                    INDEX: index,
                }
                break
            }
            case 'input_gyro': {
                let index = 3
                if (sensorC.fields.PORT.value?.slice(-1) === 'Y') {
                    index = 4
                } else if (sensorC.fields.PORT.value?.slice(-1) === 'Z') {
                    index = 5
                }

                params = {
                    INDEX: index,
                }
                break
            }
            case 'input_microphone':
            case 'input_temperature':
            case 'input_battery': {
                params = {}
                break
            }
            case 'input_ultrasonic':
            case 'input_ultrasonic_v2': {
                let port = sensorC.fields.PORT.value
                params = {
                    PORT: port,
                    PORT_No1: portMaping?.[sensorC.fields.PORT.value + '1'] ?? sensorC.fields.PORT.value + '1',
                    PORT_No2: portMaping?.[sensorC.fields.PORT.value + '2'] ?? sensorC.fields.PORT.value + '2',
                }
                libraryDependentFeatures.push('ultrasonic')
                break
            }
            case 'input_digital_read': {
                params = {
                    PORT: sensorC.fields.PORT.value,
                    PORT_No: portMaping?.[sensorC.fields.PORT.value] ?? sensorC.fields.PORT.value,
                }
                break
            }
            case 'input_variable': {
                params = {
                    VAR_NAME: variableNameMap[sensorC.fields.PORT.value],
                }
                break
            }
            // case 'input_battery': {
            // }
            case 'listcontents': {
                const listName = sensorC.fields.LIST?.value
                    ?.trim()
                    ?.replace(/\s+/g, '_')
                return listName
            }
            case 'itemoflist': {
                const listName = sensorC.fields.LIST?.value
                    ?.trim()
                    ?.replace(/\s+/g, '_')

                const values = getValue(
                    targets,
                    sensorC,
                    imports_array,
                    code_array,
                    init_array,
                    variables_data,
                    libraryDependentFeatures
                )

                params = {
                    LIST: listName,
                    INDEX: values?.[0],
                }
                break
            }

            case 'itemnumoflist': {
                const listName = sensorC.fields.LIST?.value
                    ?.trim()
                    ?.replace(/\s+/g, '_')
                let listType = variables_data.listInfo.get(listName) ?? 'STRING'

                const values = getValue(
                    targets,
                    sensorC,
                    imports_array,
                    code_array,
                    init_array,
                    variables_data,
                    libraryDependentFeatures
                )
                let variableValue = values[0]?.replace(/"/g, '') ?? ''

                params = {
                    LIST: listName,
                    ITEM: listType === 'NUMBER' ? variableValue : values?.[0],
                }
                break
            }

            case 'lengthoflist': {
                const listName = sensorC.fields.LIST?.value
                    ?.trim()
                    ?.replace(/\s+/g, '_')

                params = {
                    LIST: listName,
                }
                break
            }

            case 'listcontainsitem': {
                const listName = sensorC.fields.LIST?.value
                    ?.trim()
                    ?.replace(/\s+/g, '_')
                let listType = variables_data.listInfo.get(listName) ?? 'STRING'

                const values = getValue(
                    targets,
                    sensorC,
                    imports_array,
                    code_array,
                    init_array,
                    variables_data,
                    libraryDependentFeatures
                )
                let variableValue = values[0]?.replace(/"/g, '') ?? ''

                params = {
                    LIST: listName,
                    ITEM: listType === 'NUMBER' ? variableValue : values?.[0],
                }
                break
            }
        }

        const result = blockToCode({
            blockType: currentBlockOpcode,
            params,
        })

        if (!imports_array.includes(result.imports))
            imports_array.push(result.imports)
        if (!init_array.includes(result.initCode))
            init_array.push(result.initCode)

        return result.useCode
    } else if (currentBlockOpcode === 'input_fourinone') {
        let sensor = sensorC.fields.PORT.value
        let value = ''
        let initCode2 = ''
        switch (sensor) {
            case 'Red':
            case 'Green':
            case 'Blue': {
                value = `read_color_${sensor.toLowerCase()}`
                if (!init_array.includes('apds.enable_color_sensor()')) {
                    initCode2 = 'apds.enable_color_sensor()'
                }
                break
            }
            case 'Proximity': {
                value = `read_proximity`
                if (!init_array.includes('apds.enable_proximity_sensor()')) {
                    initCode2 = 'apds.enable_proximity_sensor()'
                }
                break
            }
            case 'Light': {
                value = `read_light`
                if (!init_array.includes('apds.enable_light_sensor()')) {
                    initCode2 = 'apds.enable_light_sensor()'
                }

                break
            }
            case 'Gesture': {
                value = `read_gesture`
                if (!init_array.includes('apds.enable_gesture_sensor()')) {
                    initCode2 = 'apds.enable_gesture_sensor()'
                }

                break
            }
        }
        const result = blockToCode({
            blockType: currentBlockOpcode,
            params: {
                VALUE: value,
            },
        })

        if (!init_array.includes(result.initCode))
            init_array.push(result.initCode)
        if (initCode2) {
            init_array.push(initCode2)
        }

        return result.useCode
    }

    if (removeDeviceName(sensorC.opcode) === 'input_shakingstrength') {
        return 'get_shake_strength()'
    }

    if (removeDeviceName(sensorC.opcode) === 'input_ultrasonic') {
        if (
            !C_init.includes(
                `ultrasonic_sensor_t sensor${sensorC.fields.PORT.value}  = ultrasonic_set_port(P${sensorC.fields.PORT.value}1,P${sensorC.fields.PORT.value}2);`
            )
        )
            C_init.push(
                `ultrasonic_sensor_t sensor${sensorC.fields.PORT.value}  = ultrasonic_set_port(P${sensorC.fields.PORT.value}1,P${sensorC.fields.PORT.value}2);`
            )
        return `ultrasonic_read_cm(sensor${sensorC.fields.PORT.value})`
    }
}
const branch = (
    target,
    targets,
    imports_array,
    code_array,
    init_array,
    variables_data,
    libraryDependentFeatures
) => {
    var current_bblock = target

    while (current_bblock) {
        condition(
            current_bblock,
            targets,
            imports_array,
            code_array,
            init_array,
            variables_data,
            libraryDependentFeatures
        )
        if (current_bblock.opcode === 'procedures_call') {
            // console.log('GGGGGGGGGHHHHHHHH', target, targets)

            let funArguments = getArguments(
                targets,
                current_bblock,
                imports_array,
                code_array,
                init_array,
                variables_data,
                libraryDependentFeatures
            )

            // funArguments = funArguments.map((a) => {
            //     if (/^".*"$/.test(a)) {
            //         let replaceA = a?.replace(/"/g, '') ?? ''
            //         if (!isNaN(replaceA) && replaceA !== '') {
            //             return replaceA
            //         }
            //     }

            //     return a
            // })

            let proccodeData = current_bblock.mutation.proccode
            let funcName = proccodeData?.replace(/%/g, '')?.replace(/\s+/g, '_')

            code_array.push(`${funcName}(${funArguments.join(', ')});`)
        }
        // console.log('HHHHHHHHHHHHHXXXXXXXXXXXXXX', current_bblock)
        ////////////////// ALL OUTPUT  BLOCK /////////////////////////
        let currentBlockOpcode = removeDeviceName(current_bblock.opcode)
        if (
            [
                'output_print',
                'output_digital',
                'output_analog',
                'smileLED_output',
                'output_servo',
                'output_motor',
                'output_incremental_servo',
                'output_rgb',
                'output_led',
                'output_set_motor',
                'output_buzzer',
                'output_stop_buzzers',
                'output_oled',
                'output_clear_oled',
                'output_variable',
                'setvariableto',
                'changevariableby',
                'initlist',
                'addtolist',
                'deleteoflist',
                'deletealloflist',
                'insertatlist',
                'replaceitemoflist',
            ].includes(currentBlockOpcode)
        ) {
            let params = {}

            switch (currentBlockOpcode) {
                case 'output_print': {
                    let value = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )
                    params = {
                        VALUE: value[0],
                    }
                    break
                }
                case 'output_digital': {
                    const _dPort = current_bblock.fields.PORT.value
                    // Extensions use 'High'/'Low' (PeeCee) or 'HIGH'/'LOW' (Toki/Poki)
                    // Normalise with case-insensitive comparison so both work.
                    const _isHigh = String(current_bblock.fields.VALUE.value).toUpperCase() === 'HIGH'
                    params = {
                        PORT: _dPort,
                        PORT_No: portMaping?.[_dPort] ?? _dPort,
                        VALUE: _isHigh ? 'HIGH' : 'LOW',
                        VALUE_PY: _isHigh ? 1 : 0,
                    }
                    break
                }

                case 'output_variable': {
                    params = {
                        VAR_NAME:
                            variableNameMap[current_bblock.fields.PORT.value],
                        VALUE: current_bblock.fields.VALUE.value,
                    }
                    break
                }

                case 'output_analog': {
                    let value = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )
                    const _aPort = current_bblock.fields.PORT.value
                    params = {
                        PORT: _aPort,
                        PORT_No: portMaping?.[_aPort] ?? _aPort,
                        VALUE: value[0],
                    }
                    break
                }
                case 'output_servo': {
                    let values = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )
                    let servoType = current_bblock.fields.MOTOR_TYPE.value

                    let value = values[0]
                    if (servoType == '270') {
                        value = `int(${values[0]} * 0.667)`
                    }

                    params = {
                        PORT: current_bblock.fields.PORT.value,
                        PORT_No: (() => {
                            const _p = current_bblock.fields.PORT.value
                            return portMaping?.[`S${_p}`] ?? portMaping?.[_p] ?? _p
                        })(),
                        VALUE: value,
                    }
                    break
                }
                case 'output_motor': {
                    let values = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )
                    let direction = current_bblock.fields.DIRECTION.value

                    let value
                    if (direction === 'ANTI-CLOCKWISE') {
                        value = `int(90 + (${values[0]} / 100) * 90)`
                    } else {
                        value = `int(90 - (${values[0]} / 100) * 90)`
                    }

                    params = {
                        PORT: current_bblock.fields.PORT.value,
                        PORT_No:
                            portMaping?.[current_bblock.fields.PORT.value] ??
                            current_bblock.fields.PORT.value,
                        VALUE: value,
                    }
                    break
                }
                case 'output_incremental_servo': {
                    let values = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )
                    let value = `int(90 - (${values[0]} / 100) * 90)`

                    params = {
                        PORT: current_bblock.fields.PORT.value,
                        PORT_No: (() => {
                            const _p = current_bblock.fields.PORT.value
                            return portMaping?.[`S${_p}`] ?? portMaping?.[_p] ?? _p
                        })(),
                        VALUE: value,
                    }
                    break
                }
                case 'smileLED_output': {
                    let ledNum = current_bblock.fields.PORT.value
                    const _smileHigh = String(current_bblock.fields.VALUE.value).toUpperCase() === 'HIGH'
                    let value = _smileHigh ? 'on' : 'off'
                    // PeeCee smile LED GPIO pins (left to right): 1→37, 2→41, 3→21, 4→35
                    const _SMILE_PINS = { '1': 37, '2': 41, '3': 21, '4': 35 }
                    const _smilePin = _SMILE_PINS[String(ledNum)] ?? 37
                    params = {
                        VALUE: value,
                        LEDNUM: ledNum,
                        SMILE_PIN: _smilePin,
                        SMILE_STATE: value === 'on' ? 'HIGH' : 'LOW',
                    }
                    break
                }
                case 'output_led': {
                    value = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )
                    // Use device-specific pin for internal RGB/eye LEDs.
                    // portMaping['RGB'] holds the eyes/NeoPixel data pin per device:
                    //   PeeCee → 36, Roboki → 0, Zing/Crawle → 10
                    const _rgbPin = portMaping?.['RGB'] ?? 36
                    params = {
                        INDEX: current_bblock.fields.PORT.value,
                        R: value[0],
                        G: value[1],
                        B: value[2],
                        RGB_PIN: _rgbPin,
                    }
                    break
                }
                case 'output_set_motor': {
                    let portValue = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )
                    let speed1 = 0,
                        speed2 = 0,
                        port1 = 'Select_Port1',
                        port2 = 'Select_Port2',
                        PORT_No1 = '',
                        PORT_No2 = ''
                    // var portChar =
                    //     current_bblock.fields.PORT.value !== 'Select Port'
                    //         ? current_bblock.fields.PORT.value.charAt(0)
                    //         : 'Select Port'
                    let direction = current_bblock.fields.DIRECTION.value
                    if (direction === 'CLOCKWISE') {
                        speed1 = portValue[0]
                    } else {
                        speed2 = portValue[0]
                    }

                    // for peecee M port maping to the L port, so change the portChar
                    if (current_bblock.fields.PORT.value === 'M1') {
                        port1 = 'M1'
                        port2 = 'M2'
                    } else if (current_bblock.fields.PORT.value === 'M2') {
                        port1 = 'M3'
                        port2 = 'M4'
                    } else {
                        port1 = current_bblock.fields.PORT.value + 1
                        port2 = current_bblock.fields.PORT.value + 2
                    }
                    PORT_No1 = portMaping[port1] ?? 'select_port'
                    PORT_No2 = portMaping[port2] ?? 'select_port'

                    params = {
                        // PORT: portChar,
                        PORT1: port1,
                        PORT2: port2,
                        PORT_No1,
                        PORT_No2,
                        SPEED1: speed1,
                        SPEED2: speed2,
                    }
                    break
                }
                case 'output_motor': {
                    break
                }
                case 'output_touchpad': {
                    break
                }
                case 'output_rgb': {
                    let value = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )

                    let index = Number(current_bblock.fields.PORT.value)
                    if (Number.isNaN(index)) {
                        index = current_bblock.fields.PORT.value
                    } else {
                        index = index - 1
                    }

                    params = {
                        INDEX: index,
                        R: value[0],
                        G: value[1],
                        B: value[2],
                        RGB_PIN: portMaping?.['B1'] ?? 4,
                    }
                    break
                }
                case 'output_buzzer': {
                    // Buzzer VALUE is a LOCKED_STRING → stored as a field, not an
                    // input, so getValue() (which only reads inputs) returned []
                    // and VALUE came out `undefined`. Read the field directly.
                    params = {
                        VALUE: current_bblock.fields.VALUE.value,
                    }
                    break
                }
                case 'output_oled': {
                    const oledPortRaw = current_bblock.fields.PORT.value

                    if (oledPortRaw === 'Sensor Value') {
                        const sensorPort = current_bblock.fields.VALUE1?.value ?? 'A1'
                        const internalSensorMap = {
                            'Accelerometer X': { init: `qmi8658 = Qmi8658()`, use: `qmi8658.read_xyz()[0]`, initKey: 'qmi8658' },
                            'Accelerometer Y': { init: `qmi8658 = Qmi8658()`, use: `qmi8658.read_xyz()[1]`, initKey: 'qmi8658' },
                            'Accelerometer Z': { init: `qmi8658 = Qmi8658()`, use: `qmi8658.read_xyz()[2]`, initKey: 'qmi8658' },
                            'Gyro X':          { init: `qmi8658 = Qmi8658()`, use: `qmi8658.read_xyz()[3]`, initKey: 'qmi8658' },
                            'Gyro Y':          { init: `qmi8658 = Qmi8658()`, use: `qmi8658.read_xyz()[4]`, initKey: 'qmi8658' },
                            'Gyro Z':          { init: `qmi8658 = Qmi8658()`, use: `qmi8658.read_xyz()[5]`, initKey: 'qmi8658' },
                            'Microphone':      { init: `mic = Mic()`, use: `mic.read()`, initKey: 'mic' },
                            'Temperature':     { init: `temp = ADC(Pin(TEMP_PIN))\ntemp.atten(ADC.ATTN_11DB)`, use: `temp.read()`, initKey: 'temp' },
                            'Battery':         { init: `bat = Battery()`, use: `bat.get_level()`, initKey: 'bat' },
                            'Touch 0':         { init: `t0 = TouchPad(Pin(PORT_T0))`, use: `t0.read()`, initKey: 't0' },
                            'Touch 1':         { init: `t1 = TouchPad(Pin(PORT_T1))`, use: `t1.read()`, initKey: 't1' },
                            'Touch 2':         { init: `t2 = TouchPad(Pin(PORT_T2))`, use: `t2.read()`, initKey: 't2' },
                            'Touch 3':         { init: `t3 = TouchPad(Pin(PORT_T3))`, use: `t3.read()`, initKey: 't3' },
                            'Red':             { init: `apds = Apds()`, use: `apds.read_color_red()`,   initKey: 'apds', extra: `apds.enable_color_sensor()` },
                            'Green':           { init: `apds = Apds()`, use: `apds.read_color_green()`, initKey: 'apds', extra: `apds.enable_color_sensor()` },
                            'Blue':            { init: `apds = Apds()`, use: `apds.read_color_blue()`,  initKey: 'apds', extra: `apds.enable_color_sensor()` },
                            'Proximity':       { init: `apds = Apds()`, use: `apds.read_proximity()`,   initKey: 'apds', extra: `apds.enable_proximity_sensor()` },
                            'Light':           { init: `apds = Apds()`, use: `apds.read_light()`,       initKey: 'apds', extra: `apds.enable_light_sensor()` },
                            'Gesture':         { init: `apds = Apds()`, use: `apds.read_gesture()`,     initKey: 'apds', extra: `apds.enable_gesture_sensor()` },
                        }
                        let sensorInit, sensorRead, initKey
                        const internalEntry = internalSensorMap[sensorPort]
                        if (internalEntry) {
                            sensorInit = internalEntry.init
                            sensorRead = internalEntry.use
                            initKey = internalEntry.initKey
                            if (!init_array.some(e => e.includes(initKey))) {
                                init_array.push(sensorInit)
                            }
                            if (internalEntry.extra && !init_array.includes(internalEntry.extra)) {
                                init_array.push(internalEntry.extra)
                            }
                        } else {
                            const sensorPortBase = sensorPort.slice(0, -1)
                            let sensorKind = 'analog'
                            const varName = `port_${sensorPort}`
                            for (const blk of Object.values(targets)) {
                                const op = removeDeviceName(blk.opcode ?? '')
                                if (op === 'input_digital' && blk.fields?.PORT?.value === sensorPort) {
                                    sensorKind = 'digital'
                                    break
                                }
                                if (op === 'input_ultrasonic' && blk.fields?.PORT?.value === sensorPortBase) {
                                    sensorKind = 'ultrasonic'
                                    break
                                }
                            }
                            if (sensorKind === 'digital') {
                                sensorInit = `${varName} = Pin(PORT_${sensorPort}, Pin.IN)`
                                sensorRead = `${varName}.value()`
                                initKey = varName
                            } else if (sensorKind === 'ultrasonic') {
                                sensorInit = `sensor_${sensorPortBase} = HCSR04(trigger_pin=PORT_${sensorPortBase}1, echo_pin=PORT_${sensorPortBase}2)`
                                sensorRead = `sensor_${sensorPortBase}.distance_mm()`
                                initKey = `sensor_${sensorPortBase}`
                                if (!imports_array.includes('from hcsr04 import HCSR04')) {
                                    imports_array.push('from hcsr04 import HCSR04')
                                }
                                if (!libraryDependentFeatures.includes('ultrasonic')) {
                                    libraryDependentFeatures.push('ultrasonic')
                                }
                            } else {
                                sensorInit = `${varName} = ADC(Pin(PORT_${sensorPort}))\n${varName}.atten(ADC.ATTN_11DB)`
                                sensorRead = `${varName}.read()`
                                initKey = varName
                            }
                            if (!init_array.some(entry => entry.includes(initKey))) {
                                init_array.push(sensorInit)
                            }
                        }
                        do { oledSensorLineCount++ } while (oledUsedLines.has(String(oledSensorLineCount)))
                        oledUsedLines.add(String(oledSensorLineCount))
                        params = {
                            TEXT: sensorRead,
                            LINE: String(oledSensorLineCount),
                        }
                    } else {
                        var values = getValue(
                            targets,
                            current_bblock,
                            imports_array,
                            code_array,
                            init_array,
                            variables_data,
                            libraryDependentFeatures
                        )
                        const oledLineNum = /Line (\d)/.exec(oledPortRaw)?.[1] ?? '1'
                        oledUsedLines.add(oledLineNum)
                        params = {
                            TEXT: values[0],
                            LINE: oledLineNum,
                        }
                    }
                    break
                }
                case 'setvariableto': {
                    let variableName = current_bblock.fields.VARIABLE.value
                        ?.trim()
                        ?.replace(/\s+/g, '_')
                    let variableType = current_bblock.fields.VAR_TYPE.value

                    variables_data.variableInfo.set(variableName, variableType)

                    let value = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )

                    let variableValue = value[0]?.replace(/"/g, '') ?? ''
                    // C mode: declare variable with type in C_init (setup) on first use
                    if (!isMicroPythonMode) {
                        const _cType = variableType === 'NUMBER' ? 'float' : 'String'
                        const _decl = `${_cType} ${variableName} = ${variableType === 'NUMBER' ? '0' : '""'};`
                        if (!C_init.includes(_decl)) C_init.push(_decl)
                    }
                    params = {
                        VARIABLE: variableName,
                        VALUE:
                            variableType === 'NUMBER'
                                ? variableValue
                                : value[0],
                    }
                    break
                }
                case 'changevariableby': {
                    let variableName = current_bblock.fields.VARIABLE.value
                        ?.trim()
                        ?.replace(/\s+/g, '_')
                    let variableType =
                        variables_data.variableInfo.get(variableName) ??
                        'STRING'
                    let value = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )

                    let variableValue = value[0]?.replace(/"/g, '') ?? ''
                    // const isNumber =
                    //     !isNaN(variableValue) && variableValue !== ''

                    params = {
                        VARIABLE: variableName,
                        VALUE:
                            variableType === 'NUMBER'
                                ? variableValue
                                : value[0],
                    }
                    break
                }

                case 'initlist': {
                    const listName = current_bblock.fields.LIST?.value
                        ?.trim()
                        ?.replace(/\s+/g, '_')

                    let listType = current_bblock.fields.ITEM_TYPE?.value
                    variables_data.listInfo.set(listName, listType)

                    const lengthValue = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )

                    params = {
                        LIST: listName,
                        LENGTH: lengthValue?.[0] ?? 0,
                    }
                    break
                }

                case 'addtolist': {
                    const listName = current_bblock.fields.LIST?.value
                        ?.trim()
                        ?.replace(/\s+/g, '_')
                    let listType =
                        variables_data.listInfo.get(listName) ?? 'STRING'

                    const values = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )
                    let variableValue = values[0]?.replace(/"/g, '') ?? ''

                    params = {
                        LIST: listName,
                        ITEM:
                            listType === 'NUMBER' ? variableValue : values?.[0],
                    }
                    break
                }

                case 'deleteoflist': {
                    const listName = current_bblock.fields.LIST?.value
                        ?.trim()
                        ?.replace(/\s+/g, '_')

                    const values = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )

                    params = {
                        LIST: listName,
                        INDEX: values?.[0],
                    }
                    break
                }

                case 'deletealloflist': {
                    const listName = current_bblock.fields.LIST?.value
                        ?.trim()
                        ?.replace(/\s+/g, '_')

                    params = {
                        LIST: listName,
                    }
                    break
                }

                case 'insertatlist': {
                    const listName = current_bblock.fields.LIST?.value
                        ?.trim()
                        ?.replace(/\s+/g, '_')
                    let listType =
                        variables_data.listInfo.get(listName) ?? 'STRING'

                    const values = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )
                    let variableValue = values[0]?.replace(/"/g, '') ?? ''

                    params = {
                        LIST: listName,
                        ITEM:
                            listType === 'NUMBER' ? variableValue : values?.[0],
                        INDEX: values?.[1],
                    }
                    break
                }

                case 'replaceitemoflist': {
                    const listName = current_bblock.fields.LIST?.value
                        ?.trim()
                        ?.replace(/\s+/g, '_')
                    let listType =
                        variables_data.listInfo.get(listName) ?? 'STRING'

                    const values = getValue(
                        targets,
                        current_bblock,
                        imports_array,
                        code_array,
                        init_array,
                        variables_data,
                        libraryDependentFeatures
                    )
                    let variableValue = values[1]?.replace(/"/g, '') ?? ''

                    params = {
                        LIST: listName,
                        INDEX: values?.[0],
                        ITEM:
                            listType === 'NUMBER' ? variableValue : values?.[1],
                    }
                    break
                }
            }

            let result = blockToCode({
                blockType: currentBlockOpcode,
                params,
            })
            // console.log('JJJJJJJJJJJJJ', result)

            // Special case: buzzer frequency 0 → stop the buzzer
            if (result.useCode === 'buzzer.set_freq(0)' || result.useCode === `tone(${portMaping?.['BUZZER_PIN'] ?? 45}, (int)(0) * 10);`) {
                result.useCode = isMicroPythonMode ? 'buzzer.stop()' : `noTone(${portMaping?.['BUZZER_PIN'] ?? 45});`
            }
            if (!imports_array.includes(result.imports))
                imports_array.push(result.imports)
            if (!init_array.includes(result.initCode))
                init_array.push(result.initCode)
            code_array.push(result.useCode)

            var next_bblock = current_bblock.next
            current_bblock = next_bblock === null ? null : targets[next_bblock]
            continue
        }

        if (removeDeviceName(current_bblock.opcode) === 'output_motor') {
            var value
            const _speedBlk = targets[current_bblock.inputs.SPEED.block]
            if (_speedBlk.fields.NUM !== undefined) {
                const _spd = Number(_speedBlk.fields.NUM.value)
                value = current_bblock.fields.DIRECTION.value === 'CLOCKWISE' ? _spd + 100 : _spd - 100
            } else if (_speedBlk.fields.VALUE !== undefined) {
                const _spd = _speedBlk.fields.VALUE.value
                value = current_bblock.fields.DIRECTION.value === 'CLOCKWISE'
                    ? `(int)(${_spd}) + 100` : `(int)(${_spd}) - 100`
            } else {
                const _spd = _speedBlk.fields.VARIABLE.value.replace(/\s/g, '')
                value = current_bblock.fields.DIRECTION.value === 'CLOCKWISE'
                    ? `(int)(${_spd}) + 100` : `(int)(${_spd}) - 100`
            }
            if (isMicroPythonMode) {
                code_array.push(`servo_set_direction(P${current_bblock.fields.PORT.value},${value});`)
                if (!C_init.includes(`enable_servo_on(P${current_bblock.fields.PORT.value});`))
                    C_init.push(`enable_servo_on(P${current_bblock.fields.PORT.value});`)
            } else {
                const _mPort = current_bblock.fields.PORT.value
                const _mPin = portMaping?.[`S${_mPort}`] ?? portMaping?.[`M${_mPort}`] ?? portMaping?.[_mPort]
                if (_mPin !== undefined) {
                    if (!C_init.includes(`ledcAttach(${_mPin}, 50, 8);`))
                        C_init.push(`ledcAttach(${_mPin}, 50, 8);`)
                    code_array.push(`ledcWrite(${_mPin}, constrain(map((int)(${value}), -200, 200, 0, 255), 0, 255));`)
                } else {
                    code_array.push(`// motor port ${_mPort} (pin not mapped)`)
                }
            }
        }

        if (
            removeDeviceName(current_bblock.opcode) === 'output_led_animation'
        ) {
            if (isMicroPythonMode) {
                code_array.push(
                    '\tset_led_pattern(ledanimate,' +
                        current_bblock.fields.PORT.value
                            .replace(/\s/g, '_')
                            .toUpperCase() +
                        ');'
                )
                if (!C_init.includes('led_strip_t * ledanimate = rgb_eyes_init();'))
                    C_init.push('led_strip_t * ledanimate = rgb_eyes_init();')
            } else {
                code_array.push(`// LED animation: ${current_bblock.fields.PORT.value}`)
                code_array.push(`neopixelWrite(${portMaping?.['RGB'] ?? 36}, 0, 128, 255);`)
            }
        }
        if (
            removeDeviceName(current_bblock.opcode) ===
            'output_led_display_secs'
        ) {
            var value = getValue(
                targets,
                current_bblock,
                imports_array,
                code_array,
                init_array,
                variables_data,
                libraryDependentFeatures
            )
            var color = hexToRgb(
                targets[current_bblock.inputs.COLOR.block].fields.COLOUR.value
            )
            if (isMicroPythonMode) {
                code_array.push(
                    '\trgb_set_hsv_for(ledwithtime,' +
                        current_bblock.fields.PORT.value + ',' +
                        color.r + ',' + color.g + ',' + color.b + ',' +
                        value[0] * 1000 + ');'
                )
                if (!C_init.includes('led_strip_t * ledwithtime = rgb_eyes_init();'))
                    C_init.push('led_strip_t * ledwithtime = rgb_eyes_init();')
            } else {
                code_array.push(`neopixelWrite(${portMaping?.['RGB'] ?? 36}, ${color.r}, ${color.g}, ${color.b});`)
                code_array.push(`delay(${value[0] * 1000});`)
                code_array.push(`neopixelWrite(${portMaping?.['RGB'] ?? 36}, 0, 0, 0);`)
            }
        }
        if (removeDeviceName(current_bblock.opcode) === 'output_led_display') {
            var color = hexToRgb(
                targets[current_bblock.inputs.COLOR.block].fields.COLOUR.value
            )
            if (isMicroPythonMode) {
                code_array.push(
                    '\trgb_set_hsv(ledwithouttime,' +
                        current_bblock.fields.PORT.value + ',' +
                        color.r + ',' + color.g + ',' + color.b + ');'
                )
                if (!C_init.includes('led_strip_t * ledwithouttime = rgb_eyes_init();'))
                    C_init.push('led_strip_t * ledwithouttime = rgb_eyes_init();')
            } else {
                code_array.push(`neopixelWrite(${portMaping?.['RGB'] ?? 36}, ${color.r}, ${color.g}, ${color.b});`)
            }
        }
        if (removeDeviceName(current_bblock.opcode) === 'output_turnoff_led') {
            if (isMicroPythonMode) {
                code_array.push(
                    '\trgb_set_hsv(' +
                        current_bblock.fields.PORT.value + ',' +
                        current_bblock.fields.VALUE.value + ',0,0,0);'
                )
                if (!C_init.includes(`led_strip_t * ${current_bblock.fields.PORT.value} = rgb_eyes_init();`))
                    C_init.push(`led_strip_t * ${current_bblock.fields.PORT.value} = rgb_eyes_init();`)
            } else {
                code_array.push(`neopixelWrite(${portMaping?.['RGB'] ?? 36}, 0, 0, 0);`)
            }
        }
        if (
            removeDeviceName(current_bblock.opcode) === 'output_refresh_pixels'
        ) {
            var variable = current_bblock.fields.PORT.value
            code_array.push(`\trefresh_pixels(${variable});`)
        }
        if (removeDeviceName(current_bblock.opcode) === 'output_playsoundfor') {
            var freq =
                targets[current_bblock.inputs.VALUE1.block].fields.NUM.value
            var time =
                targets[current_bblock.inputs.VALUE2.block].fields.NUM.value
            if (isMicroPythonMode) {
                code_array.push(`buzzer_set_frequency(${freq});`)
                code_array.push('delay_ms(' + time * 1000 + ');')
                if (!C_init.includes('buzzer_init();')) C_init.push('buzzer_init();')
            } else {
                code_array.push(`tone(${portMaping?.['BUZZER_PIN'] ?? 45}, ${freq}, ${time * 1000});`)
                code_array.push(`delay(${time * 1000});`)
            }
        }
        if (removeDeviceName(current_bblock.opcode) === 'output_playsoundat') {
            var freq = getValue(
                targets,
                current_bblock,
                imports_array,
                code_array,
                init_array,
                variables_data,
                libraryDependentFeatures
            )
            if (isMicroPythonMode) {
                code_array.push('\tbuzzer_set_frequency(' + freq[0] + ');')
                if (!C_init.includes('buzzer_init();')) C_init.push('buzzer_init();')
            } else {
                code_array.push(`tone(${portMaping?.['BUZZER_PIN'] ?? 45}, ${freq[0]});`)
            }
        }
        ////////////////// ACE BLOCKS END //////////////////////

        //////////////////// ZING/HEXAPOD BLOCKS ////////////////////
        if (removeDeviceName(current_bblock.opcode) === 'output_move_forward') {
            code_array.push('set_action(MOVE_FORWARD);')
        }
        if (
            removeDeviceName(current_bblock.opcode) === 'output_move_backward'
        ) {
            code_array.push('set_action(MOVE_BACKWARD);')
        }
        if (removeDeviceName(current_bblock.opcode) === 'output_turnright') {
            code_array.push('set_action(TURN_RIGHT);')
        }
        if (removeDeviceName(current_bblock.opcode) === 'output_turnleft') {
            code_array.push('set_action(TURN_LEFT);')
        }
        if (removeDeviceName(current_bblock.opcode) === 'output_action') {
            var action = current_bblock.fields.PORT.value.replace(/\s/g, '_')
            code_array.push(`set_action(${action});`)
        }
        if (removeDeviceName(current_bblock.opcode) === 'output_mp3') {
            var songNo = getValue(
                targets,
                current_bblock,
                imports_array,
                code_array,
                init_array,
                variables_data,
                libraryDependentFeatures
            )
            code_array.push(`set_song(${songNo[0]});`)
        }
        if (removeDeviceName(current_bblock.opcode) === 'output_serial_servo') {
            var port = current_bblock.fields.PORT.value
            var range =
                targets[current_bblock.inputs.VALUE.block].fields.NUM.value
            var time =
                targets[current_bblock.inputs.TIME.block].fields.NUM.value
            code_array.push(`serial_servo_move(${port},${range},${time});`)
        }
        ////////////////// ZING/HEXAPOD BLOCKS END //////////////////////

        var next_bblock = current_bblock.next
        current_bblock = next_bblock === null ? null : targets[next_bblock]
    }
    return
}
const operator = (
    target,
    targets,
    imports_array,
    code_array,
    init_array,
    variables_data,
    libraryDependentFeatures
) => {
    // console.log('UUUUUUUUUU', target, targets)
    switch (target.opcode) {
        case 'operator_add': {
            let value = getValue(
                targets,
                target,
                imports_array,
                code_array,
                init_array,
                variables_data,
                libraryDependentFeatures
            )

            return `${value[0]} + ${value[1]}`
        }
        case 'operator_subtract': {
            let value = getValue(
                targets,
                target,
                imports_array,
                code_array,
                init_array,
                variables_data,
                libraryDependentFeatures
            )

            return `${value[0]} - ${value[1]}`
        }
        case 'operator_multiply': {
            let value = getValue(
                targets,
                target,
                imports_array,
                code_array,
                init_array,
                variables_data,
                libraryDependentFeatures
            )

            return `${value[0]} * ${value[1]}`
        }
        case 'operator_divide': {
            let value = getValue(
                targets,
                target,
                imports_array,
                code_array,
                init_array,
                variables_data,
                libraryDependentFeatures
            )

            return `${value[0]} / ${value[1]}`
        }
        case 'operator_not': {
            // notOperator = isMicroPythonMode ? 'not' : '!'
            // if (target.inputs.OPERAND !== undefined)
            //     target = targets[target.inputs.OPERAND.block]

            let value = getValue(
                targets,
                target,
                imports_array,
                code_array,
                init_array,
                variables_data,
                libraryDependentFeatures
            )
            return isMicroPythonMode ? `not (${value[0]})` : `!(${value[0]})`
        }
        case 'operator_gt': {
            let value = getValue(
                targets,
                target,
                imports_array,
                code_array,
                init_array,
                variables_data,
                libraryDependentFeatures
            )

            let op1 = value[0]?.replace(/"/g, '') ?? ''
            let op2 = value[1]?.replace(/"/g, '') ?? ''
            return `${op1} > ${op2}`
        }
        case 'operator_lt': {
            let value = getValue(
                targets,
                target,
                imports_array,
                code_array,
                init_array,
                variables_data,
                libraryDependentFeatures
            )

            let op1 = value[0]?.replace(/"/g, '') ?? ''
            let op2 = value[1]?.replace(/"/g, '') ?? ''
            return `${op1} < ${op2}`
        }
        case 'operator_equals': {
            let value = getValue(
                targets,
                target,
                imports_array,
                code_array,
                init_array,
                variables_data,
                libraryDependentFeatures
            )

            let op1 = value[0]?.replace(/"/g, '') ?? ''
            let op2 = value[1]?.replace(/"/g, '') ?? ''
            return `${op1} == ${op2}`
        }

        // case 'input_digital': {
        //     var port = target.fields.PORT.value
        //     var state = target.fields.VALUE.value

        //     const result = blockToCode({
        //         blockType: 'input_digital',
        //         params: {
        //             // NOT_OPERATOR: notOperator,
        //             PORT: port,
        //             VALUE: state === 'HIGH' ? 1 : 0,
        //         },
        //     })
        //     console.log('XXXXXXXXXXXXX', result, port, state)
        //     if (!init_array.includes(result.initCode))
        //         init_array.push(result.initCode)
        //     return result.useCode
        // }
        case 'argument_reporter_boolean': {
            // var cond = target.fields.VALUE.value
            // var notOperator = ''

            // const result = blockToCode({
            //     blockType: 'argument_reporter_boolean',
            //     params: {
            //         NOT_OPERATOR: notOperator,
            //         VALUE: cond,
            //     },
            // })
            // code_array.push(result.useCode)
            // code_array.push(`if (${notOperator}${cond}) {`)
            // var subBranch = getSubBranch(target, targets, notOperator)
            // if (subBranch !== null) {
            //     let variables_data_copy = structuredClone(variables_data)
            //     branch(
            //         subBranch,
            //         targets,
            //         imports_array,
            //         code_array,
            //         init_array,
            //         variables_data_copy,
            //         libraryDependentFeatures
            //     )
            // }
            // code_array.push('}')
            // code_array.push(BLOCK_CLOSE)
            // break

            let value = target.fields.VALUE.value
            return value
        }
    }

    if (removeDeviceName(target.opcode) === 'input_digital') {
        var port = target.fields.PORT.value
        var state = target.fields.VALUE.value

        const result = blockToCode({
            blockType: 'input_digital',
            params: {
                PORT: port,
                PORT_No: portMaping?.[port] ?? port,
                VALUE: String(state).toUpperCase() === 'HIGH' ? 1 : 0,
            },
        })
        if (!init_array.includes(result.initCode))
            init_array.push(result.initCode)
        return result.useCode
    }
    if (
        (removeDeviceName(target.opcode).includes('input') &&
            !['input_digital'].includes(removeDeviceName(target.opcode))) ||
        target.opcode.includes('data_')
    ) {
        let value = inputConditions(
            target,
            targets,
            imports_array,
            code_array,
            init_array,
            variables_data,
            libraryDependentFeatures
        )
        return value
    }
}
const repeat = (
    args,
    target,
    targets,
    imports_array,
    code_array,
    init_array,
    variables_data,
    libraryDependentFeatures
) => {
    if (args) {
        if (args <= 255) {
            const result = blockToCode({
                blockType: 'control_repeat',
                params: {
                    VALUE: args,
                },
            })
            code_array.push(result.useCode)
            if (target !== undefined) {
                let variables_data_copy = structuredClone(variables_data)
                branch(
                    target,
                    targets,
                    imports_array,
                    code_array,
                    init_array,
                    variables_data_copy,
                    libraryDependentFeatures
                )
            }
            code_array.push(BLOCK_CLOSE)
            return
        } else {
            window.alert(
                'Maximum number of allowed repeats in repeat function is 255.'
            )
        }
    } else {
        window.alert(
            'Only digits are allowed inside repeat function(blocks are not allowed).'
        )
    }
}
const forever = (
    target,
    targets,
    imports_array,
    code_array,
    init_array,
    variables_data,
    libraryDependentFeatures
) => {
    // code_array.push('while(true){ ')
    const result = blockToCode({
        blockType: 'control_forever',
    })
    code_array.push(result.useCode)

    if (target !== undefined) {
        let variables_data_copy = structuredClone(variables_data)
        branch(
            target,
            targets,
            imports_array,
            code_array,
            init_array,
            variables_data_copy,
            libraryDependentFeatures
        )
    }
    code_array.push(BLOCK_CLOSE)
    return
}
const wait = (args, imports_array, code_array) => {
    if (args * 1000 < 4294967295) {
        var times = args * 1000 //limit to 4294967295
        // code_array.push('delay_ms(' + times + ');')

        const result = blockToCode({
            blockType: 'control_wait',
            params: { VALUE: args },
        })

        if (!imports_array.includes(result.imports))
            imports_array.push(result.imports)

        code_array.push(result.useCode)

        return
    } else {
        window.alert('Maximum wait allowed is only upto 4294967 seconds')
    }
}
export const parseEachBlock = async (targets, isMicropython) => {
    // Update mode from caller so the toggle is instant (no reload required).
    if (isMicropython !== undefined) {
        isMicroPythonMode = isMicropython
        // Recompute block delimiters now that mode may have changed.
        BLOCK_OPEN  = isMicroPythonMode ? '\ue000' : '{'
        BLOCK_CLOSE = isMicroPythonMode ? '\ue001' : '}'
    }
    /* eslint-disable */console.log(...oo_oo(`3265617701_1846_4_1846_24_4`,targets))
    C_imports = []
    C_code = []
    C_init = []

    procedures_codeObj = {}
    oledSensorLineCount = 0
    oledUsedLines = new Set()
    let libraryDependentFeatures = []
    var current_block = null
    var previous_block = null
    var hat_id = null

    let variables_data = {
        variableInfo: new Map(),
        listInfo: new Map(),
    }

    for (const [key, item] of Object.entries(targets)) {
        // item is an array, so loop it

        if (item.topLevel === true) {
            // console.log('hhhhh', item)
            if (item.opcode.includes('procedures_definition')) {
                proceduresToC(
                    item,
                    targets,
                    procedures_codeObj,
                    C_imports,
                    C_init,
                    variables_data,
                    libraryDependentFeatures
                )
            }

            if (item.opcode.includes('event_whenflagclicked')) {
                hat_id = item.id
            }
        }
    }

    if (hat_id !== null) {
        current_block =
            targets[hat_id].next !== null ? targets[targets[hat_id].next] : null
        previous_block = targets[hat_id]
        try {
            if (current_block.opcode === 'control_forever') {
                // console.log('in forver')
                if (previous_block.opcode != 'event_whenflagclicked') {
                    window.alert('cannot start with foerver ')
                }
            }
        } catch (err) {}
        branch(
            current_block,
            targets,
            C_imports,
            C_code,
            C_init,
            variables_data,
            libraryDependentFeatures
        )
    }

    let final_code = []

    if (C_imports.length > 0) {
        C_imports.push('')
        final_code.push(...C_imports)
    }

    if (C_init.length > 0) {
        C_init.push('')
        final_code.push(...C_init)
    }

    Object.values(procedures_codeObj).map(({ procedures_codeArr }) => {
        final_code.push(...procedures_codeArr, '')
    })

    final_code.push(...C_code)

    /* eslint-disable */console.log(...oo_oo(`3265617701_1928_4_1928_27_4`,final_code))
    sessionStorage.setItem('C_code', JSON.stringify(final_code))
    sessionStorage.setItem(
        'libraryDependentFeatures',
        JSON.stringify(libraryDependentFeatures)
    )
    // Arduino C mode: store init lines (setup) and execution lines (loop) separately
    if (!isMicroPythonMode) {
        sessionStorage.setItem('C_setup', JSON.stringify(C_init.filter(Boolean)))
        sessionStorage.setItem(
            'C_loop',
            JSON.stringify([...C_imports.filter(Boolean), ...C_code.filter(Boolean)])
        )
    }
}

// ── Per-device GPIO port maps ─────────────────────────────────────────────
// Source: Plode Documentation (GPIO configs for each board).
// Toki/Poki use named GPIO constants (WCH CH592); all others use numbers.
// IMPORTANT: Must be declared before codeGenTemplates so portMaping is
// available when template strings are interpolated at module-load time.
const PORT_MAPS = {
    peeCee: {
        A1: 1,  A2: 2,
        B1: 4,  B2: 5,
        C1: 6,  C2: 7,
        D1: 8,  D2: 9,
        E1: 17, E2: 14,
        F1: 15, F2: 16,
        S1: 10, S2: 11,
        M1: 37, M2: 41, M3: 21, M4: 35,
        T0: 10, T1: 11, T2: 12, T3: 13,  // Touch sensors
        TEMP_PIN: 3,    // Temperature sensor
        MIC_PIN: 18,    // Microphone
        BUZZER_PIN: 45, // Buzzer
        RGB: 36,        // Eyes: 12 NeoPixels on GPIO 36
        SMILE: 37, // Smile LEDs share motor pins: LED1=37,LED2=41,LED3=21,LED4=35
    },
    klawb: {
        A1: 1,  A2: 2,
        B1: 3,  B2: 4,
        M1: 14, M2: 11, M3: 15, M4: 16,   // Motor1=14, Motor2=11, Motor3=15, Grip=16
        BASE_MOTOR: 13,
    },
    // Zing old (zing0/zing1, esp32) & Crawle old (crawle1, esp32)
    zing_old: {
        A1: 6,  A2: 7,
        B1: 4,  B2: 5,
        C1: 11, C2: 12,
        D1: 17, D2: 18,
        M1: 46, M2: 45, M3: 13, M4: 14,
        RGB: 10, ULTRASONIC: 35,
        PWM_R: 9, PWM_L: 37,
    },
    // Zing v3 (zing2/zing3, esp32s3)
    zing_new: {
        A1: 6,  A2: 7,
        C1: 11, C2: 12,
        PWM_R: 9, PWM_L: 37,
        GYRO_SDA: 48, GYRO_SCL: 47,
    },
    // Crawl-e new (crawle2/crawle3, esp32s3)
    crawle_new: {
        PWM_R: 9, PWM_L: 37,
        ULTRASONIC_ECHO: 15, ULTRASONIC_TRIG: 16,
    },
    roboki: {
        A1: 1,  A2: 2,
        B1: 3,  B2: 5,
        M1: 12, M2: 8,
        M1b: 25, M2b: 24,  // second pins for each motor driver
        S1: 22, S2: 23,
        RGB: 0, STATUS_RGB: 13,
    },
    moki: {
        S1: 1,  S2: 2,  S3: 3,  S4: 4,  S5: 5,  S6: 6,
        S7: 7,  S8: 8,  S9: 9,  S10: 10, S11: 11, S12: 12,
        M1: 13, M2: 15, M3: 17, M4: 47,
        M1b: 14, M2b: 16, M3b: 18, M4b: 48,  // second motor pins
        SW1: 33, SW2: 46,  // switches
        LED: 44, STATUS_LED: 43,  // LEDs
        IR: 21,  // IR receiver
    },
    toki: {
        M1: 'GPIOA_NUM_12', M2: 'GPIOB_NUM_4',
        M1b: 'GPIOA_NUM_13', M2b: 'GPIOB_NUM_7',
        S1: 'GPIOA_NUM_10', S2: 'GPIOA_NUM_11',
        A1: 'GPIOA_NUM_14', A2: 'GPIOA_NUM_15',
        AIN1: 'GPIOA_NUM_14', AIN2: 'GPIOA_NUM_15',
        STATUS_LED: 'GPIOA_NUM_8',
        IR: 'GPIOA_NUM_9',
    },
    poki: {
        M1: 'GPIOA_NUM_9', M2: 'GPIOB_NUM_7',
        M1b: 'GPIOA_NUM_11', M2b: 'GPIOB_NUM_6',
        S1: 'GPIOA_NUM_13', S2: 'GPIOB_NUM_4',
        C1: 'GPIOA_NUM_6', C2: 'GPIOA_NUM_7',
        D1: 'GPIOB_NUM_13', D2: 'GPIOA_NUM_4',
        A1: 'GPIOA_NUM_12', A2: 'GPIOB_NUM_0',
        AIN1: 'GPIOA_NUM_12', AIN2: 'GPIOB_NUM_0',
        B1: 'GPIOA_NUM_8', B2: 'GPIOB_NUM_23',
        STATUS_LED: 'GPIOA_NUM_5',
        I2C_SDA: 'GPIOB_NUM_14', I2C_SCL: 'GPIOB_NUM_15',
    },
    atr: {
        A1: 1, A2: 2, B1: 4, B2: 5,  // same as PeeCee (esp32s3 family)
        C1: 6, C2: 7, D1: 8, D2: 9,
        S1: 10, S2: 11,
        M1: 37, M2: 41, M3: 21, M4: 35,
    },
}

// Select the correct port map from the URL device + version.
const _deviceParam  = _modeParams.get('device')  || 'peeCee'
const _versionParam = _modeParams.get('version') || '1.0.0'
const _versionMajor = parseInt(_versionParam.split('.')[0], 10) || 1

function _selectPortMap(device, versionMajor) {
    if (device === 'zing') {
        return versionMajor >= 2 ? PORT_MAPS.zing_new : PORT_MAPS.zing_old
    }
    if (device === 'crawle') {
        return versionMajor >= 2 ? PORT_MAPS.crawle_new : PORT_MAPS.zing_old
    }
    return PORT_MAPS[device] || PORT_MAPS.peeCee
}

const portMaping = _selectPortMap(_deviceParam, _versionMajor)

const controlTabCodeTemplates = {
    control_wait: {
        imports: cSym(`from time import *`, ''),
        init: '',
        use: cSym('sleep({{VALUE}})', 'delay((int)({{VALUE}} * 1000));'),
        params: ['VALUE'],
    },
    control_repeat: {
        use: cSym('for i in range(0, {{VALUE}}):\ue000', 'for(int i = 0; i < (int){{VALUE}}; i++) {'),
        params: ['VALUE'],
    },
    control_forever: {
        use: cSym('while True:\ue000', 'while(1) {'),
    },
    control_if: {
        use: cSym('if {{VALUE}} :\ue000', 'if({{VALUE}}) {'),
        params: ['VALUE'],
    },
    // operator_gt: {
    //     use: 'if {{NOT_OPERATOR}} {{VALUE1}} > {{VALUE2}} :\ue000',
    //     params: ['NOT_OPERATOR', 'VALUE1', 'VALUE2'],
    // },
    // operator_lt: {
    //     use: 'if {{NOT_OPERATOR}} {{VALUE1}} < {{VALUE2}} :\ue000',
    //     params: ['NOT_OPERATOR', 'VALUE1', 'VALUE2'],
    // },
    // operator_equals: {
    //     use: 'if {{NOT_OPERATOR}} {{VALUE1}} == {{VALUE2}} :\ue000',
    //     params: ['NOT_OPERATOR', 'VALUE1', 'VALUE2'],
    // },

    argument_reporter_boolean: {
        use: cSym('if {{NOT_OPERATOR}} {{VALUE}} :\ue000', 'if({{NOT_OPERATOR}} {{VALUE}}) {'),
        params: ['NOT_OPERATOR', 'VALUE'],
    },
}

const variableTabCodeTemplates = {
    setvariableto: {
        init: '',
        use: '{{VARIABLE}} = {{VALUE}}',
        params: ['VARIABLE', 'VALUE'],
    },

    changevariableby: {
        init: '',
        use: cSym('{{VARIABLE}} = {{VALUE}}', '{{VARIABLE}} += {{VALUE}};'),
        params: ['VARIABLE', 'VALUE'],
    },

    //list code templates
    initlist: {
        init: '',
        use: cSym('{{LIST}} = []', '/* list {{LIST}} not supported in C mode */'),
        params: ['LIST'],
    },

    addtolist: {
        init: '',
        use: cSym('{{LIST}}.append({{ITEM}})', '/* addToList {{LIST}} not supported in C mode */'),
        params: ['LIST', 'ITEM'],
    },

    deleteoflist: {
        init: '',
        use: cSym('del {{LIST}}[{{INDEX}}]', '/* deleteOfList {{LIST}} not supported in C mode */'),
        params: ['LIST', 'INDEX'],
    },

    deletealloflist: {
        init: '',
        use: cSym('{{LIST}}.clear()', '/* deleteAllOfList {{LIST}} not supported in C mode */'),
        params: ['LIST'],
    },

    insertatlist: {
        init: '',
        use: cSym('{{LIST}}.insert({{INDEX}}, {{ITEM}})', '/* insertAtList {{LIST}} not supported in C mode */'),
        params: ['LIST', 'INDEX', 'ITEM'],
    },

    replaceitemoflist: {
        init: '',
        use: cSym('{{LIST}}[{{INDEX}}] = {{ITEM}}', '{{LIST}}[{{INDEX}}] = {{ITEM}};'),
        params: ['LIST', 'INDEX', 'ITEM'],
    },

    itemoflist: {
        init: '',
        use: cSym('{{LIST}}[{{INDEX}}]', '{{LIST}}[{{INDEX}}]'),
        params: ['LIST', 'INDEX'],
    },

    itemnumoflist: {
        init: '',
        use: cSym('{{LIST}}.index({{ITEM}})', '0 /* itemnumoflist not supported in C mode */'),
        params: ['LIST', 'ITEM'],
    },

    lengthoflist: {
        init: '',
        use: cSym('len({{LIST}})', '0 /* lengthoflist not supported in C mode */'),
        params: ['LIST'],
    },

    listcontainsitem: {
        init: '',
        use: cSym('{{ITEM}} in {{LIST}}', 'false /* listcontainsitem not supported in C mode */'),
        params: ['LIST', 'ITEM'],
    },
}

const newFunctionCodeTemplates = {
    procedures_call: {
        init: '',
        use: cSym('{{FUN_NAME}} ({{FUN_ARGUMENTS}})', '{{FUN_NAME}}({{FUN_ARGUMENTS}});'),
        params: ['VARIABLE', 'FUN_ARGUMENTS'],
    },

    procedures_prototype: {
        init: '',
        use: cSym('def {{FUN_NAME}} ({{FUN_ARGUMENTS}}) :\ue000', 'void {{FUN_NAME}}({{FUN_ARGUMENTS}}) {'),
        params: ['FUN_NAME', 'FUN_ARGUMENTS'],
    },
}

const codeGenTemplates = {
    ...controlTabCodeTemplates,
    ...variableTabCodeTemplates,
    ...newFunctionCodeTemplates,

    output_print: {
        init: '',
        use: cSym(`print({{VALUE}})`, 'Serial.println({{VALUE}});'),
        params: ['VALUE'],
    },

    output_digital: {
        init: cSym('port{{PORT}} = Pin(PORT_{{PORT}}, Pin.OUT)', 'pinMode({{PORT_No}}, OUTPUT);'),
        use: cSym('port{{PORT}}.value({{VALUE_PY}})', 'digitalWrite({{PORT_No}}, {{VALUE}});'),
        params: ['PORT', 'VALUE', 'VALUE_PY', 'PORT_No'],
    },

    output_variable: {
        init: cSym(`{{VAR_NAME}} = 0`, ''),
        use: cSym(`{{VAR_NAME}} = {{VALUE}}`, '{{VAR_NAME}} = {{VALUE}};'),
        params: ['VAR_NAME', 'VALUE'],
    },

    output_analog: {
        imports: cSym(`from machine import *`, ''),
        init: cSym(`pwm{{PORT}} = PWM(PORT_{{PORT}})`, ''),
        use: cSym('pwm{{PORT}}.duty_u16(int(655.35 * {{VALUE}}))', 'analogWrite({{PORT_No}}, map((int)({{VALUE}}), 0, 100, 0, 255));'),
        params: ['PORT', 'VALUE', 'PORT_No'],
    },

    output_servo: {
        init: cSym(
            `servo{{PORT}} = PWM(Pin({{PORT_No}}))\nservo{{PORT}}.freq(50)\n\ndef move_servo(servo, angle):\n    min_pulse = 0.5\n    max_pulse = 2.5\n    pulse = min_pulse + (angle / 180) * (max_pulse - min_pulse)\n    duty = int((pulse / 20) * 65535)\n    servo.duty_u16(duty)\n        `.trim(),
            `Servo _servo{{PORT}};\n_servo{{PORT}}.attach({{PORT_No}});`
        ),
        use: cSym(` move_servo(servo{{PORT}}, {{VALUE}})`, '_servo{{PORT}}.write(constrain((int)({{VALUE}}), 0, 180));'),
        params: ['PORT', 'PORT_No', 'VALUE'],
    },
    output_motor: {
        init: cSym(
            `servo{{PORT}} = PWM(Pin({{PORT_No}}))\nservo{{PORT}}.freq(50)\n\ndef move_servo(servo, angle):\n    min_pulse = 0.5\n    max_pulse = 2.5\n    pulse = min_pulse + (angle / 180) * (max_pulse - min_pulse)\n    duty = int((pulse / 20) * 65535)\n    servo.duty_u16(duty)\n        `.trim(),
            `ledcAttach({{PORT_No}}, 50, 8);`
        ),
        use: cSym(` move_servo(servo{{PORT}}, {{VALUE}})`, 'ledcWrite({{PORT_No}}, constrain((int)({{VALUE}}), 0, 255));'),
        params: ['PORT', 'PORT_No', 'VALUE'],
    },
    output_incremental_servo: {
        init: cSym(
            `servo{{PORT}} = PWM(Pin({{PORT_No}}))\nservo{{PORT}}.freq(50)\n\ndef move_servo(servo, angle):\n    min_pulse = 0.5\n    max_pulse = 2.5\n    pulse = min_pulse + (angle / 180) * (max_pulse - min_pulse)\n    duty = int((pulse / 20) * 65535)\n    servo.duty_u16(duty)\n        `.trim(),
            `Servo _servo{{PORT}};\n_servo{{PORT}}.attach({{PORT_No}});`
        ),
        use: cSym(` move_servo(servo{{PORT}}, {{VALUE}})`, '_servo{{PORT}}.write(constrain((int)({{VALUE}}), 0, 180));'),
        params: ['PORT', 'PORT_No', 'VALUE'],
    },

    smileLED_output: {
        init: cSym('smile = SmileLed()', 'pinMode({{SMILE_PIN}}, OUTPUT);'),
        use: cSym(`smile.{{VALUE}}({{LEDNUM}})`, 'digitalWrite({{SMILE_PIN}}, {{SMILE_STATE}});'),
        params: ['LEDNUM', 'VALUE', 'SMILE_PIN', 'SMILE_STATE'],
    },
    output_led: {
        init: cSym('eyes = RgbEyes()', ''),
        use: cSym(
            `eyes.set_pixels(num={{INDEX}}, red={{R}}, green={{G}}, blue={{B}})\neyes.update_pixels()`,
            'neopixelWrite({{RGB_PIN}}, {{R}}, {{G}}, {{B}}); // eye {{INDEX}}'
        ),
        params: ['INDEX', 'R', 'G', 'B', 'RGB_PIN'],
    },
    output_set_motor: {
        init: cSym(
            `pwm{{PORT1}} = PWM({{PORT_No1}})\npwm{{PORT2}} = PWM({{PORT_No2}})`,
            `ledcAttach({{PORT_No1}}, 1000, 8);\nledcAttach({{PORT_No2}}, 1000, 8);`
        ),
        use: cSym(
            `pwm{{PORT1}}.duty_u16(int(655.35 * {{SPEED1}}))\npwm{{PORT2}}.duty_u16(int(655.35 * {{SPEED2}}))`,
            `ledcWrite({{PORT_No1}}, map((int)({{SPEED1}}), 0, 100, 0, 255));\nledcWrite({{PORT_No2}}, map((int)({{SPEED2}}), 0, 100, 0, 255));`
        ),
        params: ['PORT1', 'PORT2', 'PORT_No1', 'PORT_No2', 'SPEED1', 'SPEED2'],
    },
    output_buzzer: {
        init: cSym('buzzer = Buzzer()', ''),
        use: cSym(`buzzer.set_freq(int({{VALUE}} * .1111))`, `tone(${portMaping?.['BUZZER_PIN'] ?? 45}, (int)({{VALUE}}) * 10);`),
        params: ['VALUE'],
    },
    output_stop_buzzers: {
        init: cSym('buzzer = Buzzer()', ''),
        use: cSym(`buzzer.stop()`, `noTone(${portMaping?.['BUZZER_PIN'] ?? 45});`),
    },
    output_rgb: {
        imports: cSym(`from machine import *`, ''),
        init: cSym(`np = neopixel.NeoPixel(Pin(PORT_B1), 10)`, ''),
        use: cSym(
            `np[{{INDEX}}] = ({{R}}, {{G}}, {{B}})\nnp.write()`,
            'neopixelWrite({{RGB_PIN}}, {{R}}, {{G}}, {{B}});'
        ),
        params: ['INDEX', 'R', 'G', 'B', 'RGB_PIN'],
    },
    output_oled: {
        init: cSym('oled = Oled()', ''),
        use: cSym(
            `oled.set_text(f"{{{TEXT}}}", 10, ({{LINE}}-1)*17)\noled.show()`,
            'Serial.println({{TEXT}}); // OLED line {{LINE}}'
        ),
        params: ['TEXT', 'LINE'],
    },
    output_clear_oled: {
        init: cSym('oled = Oled()', ''),
        use: cSym(`oled.clear()`, '// oled cleared'),
    },

    //for inputs code templates
    input_digital: {
        init: cSym('port{{PORT}} = Pin(PORT_{{PORT}}, Pin.IN)', 'pinMode({{PORT_No}}, INPUT);'),
        use: cSym(`port{{PORT}}.value() == {{VALUE}}`, '(digitalRead({{PORT_No}}) == {{VALUE}})'),
        params: ['PORT', 'VALUE', 'PORT_No'],
    },
    input_analog: {
        init: cSym(
            `port{{PORT}} = ADC(Pin(PORT_{{PORT}}))\nport{{PORT}}.atten(ADC.ATTN_11DB)`,
            ''
        ),
        use: cSym(`port{{PORT}}.read()`, 'analogRead({{PORT_No}})'),
        params: ['PORT', 'PORT_No'],
    },
    input_touchpad: {
        init: cSym(`t{{TOUCH}} = TouchPad(Pin(PORT_T{{TOUCH}}))`, ''),
        use: cSym(`t{{TOUCH}}.read()`, 'touchRead({{TOUCH_PIN}})'),
        params: ['TOUCH', 'TOUCH_PIN'],
    },
    input_accelerometer: {
        init: cSym(`qmi8658 = Qmi8658()`, ''),
        use: cSym(`qmi8658.read_xyz()[{{INDEX}}]`, '0 /* accel[{{INDEX}}] */'),
        params: ['INDEX'],
    },
    input_gyro: {
        init: cSym(`qmi8658 = Qmi8658()`, ''),
        use: cSym(`qmi8658.read_xyz()[{{INDEX}}]`, '0 /* gyro[{{INDEX}}] */'),
        params: ['INDEX'],
    },
    input_temperature: {
        init: cSym(`temp = ADC(Pin(TEMP_PIN))\ntemp.atten(ADC.ATTN_11DB)`, `pinMode(${portMaping?.['TEMP_PIN'] ?? 3}, INPUT);`),
        use: cSym(`temp.read()`, `analogRead(${portMaping?.['TEMP_PIN'] ?? 3})`),
        params: [],
    },
    input_microphone: {
        init: cSym(`mic = Mic()`, `pinMode(${portMaping?.['MIC_PIN'] ?? 18}, INPUT);`),
        use: cSym(`mic.read()`, `analogRead(${portMaping?.['MIC_PIN'] ?? 18})`),
        params: [],
    },
    input_battery: {
        init: cSym(`bat = Battery()`, ''),
        use: cSym(`bat.get_level()`, '0 /* battery */'),
        params: [],
    },
    input_fourinone: {
        init: cSym('apds = Apds()', ''),
        use: cSym(`apds.{{VALUE}}()`, '0 /* 4-in-1 sensor */'),
        params: ['VALUE'],
    },
    input_ultrasonic: {
        imports: cSym(`from hcsr04 import HCSR04`, ''),
        init: cSym(
            `sensor = HCSR04(trigger_pin=PORT_{{PORT}}1, echo_pin=PORT_{{PORT}}2)`,
            ''
        ),
        use: cSym(`sensor.distance_mm()`, '_ultrasonic_mm({{PORT_No1}}, {{PORT_No2}})'),
        params: ['PORT', 'PORT_No1', 'PORT_No2'],
    },
    input_ultrasonic_v2: {
        imports: cSym(`from hcsr04 import HCSR04`, ''),
        init: cSym(
            `sensor = HCSR04(trigger_pin=PORT_{{PORT}}1, echo_pin=PORT_{{PORT}}2)`,
            ''
        ),
        use: cSym(`sensor.distance_mm()`, '_ultrasonic_mm({{PORT_No1}}, {{PORT_No2}})'),
        params: ['PORT', 'PORT_No1', 'PORT_No2'],
    },
    input_digital_read: {
        init: cSym('port{{PORT}} = Pin(PORT_{{PORT}}, Pin.IN)', 'pinMode({{PORT_No}}, INPUT);'),
        use: cSym(`port{{PORT}}.value()`, 'digitalRead({{PORT_No}})'),
        params: ['PORT', 'PORT_No'],
    },
    input_variable: {
        init: cSym(`{{VAR_NAME}} = 0`, ''),
        use: cSym(`{{VAR_NAME}}`, '{{VAR_NAME}}'),
        params: ['VAR_NAME'],
    },
}

export default codeGenTemplates
/* istanbul ignore next *//* c8 ignore start *//* eslint-disable */;function oo_cm(){try{return (0,eval)("globalThis._console_ninja") || (0,eval)("/* https://github.com/wallabyjs/console-ninja#how-does-it-work */'use strict';var _0x34ea16=_0x397e;function _0x5821(){var _0x2a97b3=['constructor','_addObjectProperty','_ninjaIgnoreNextError','split','totalStrLength','join','getOwnPropertyDescriptor','reduceOnCount','boolean','allStrLength','readyState','POSITIVE_INFINITY','_console_ninja_session','node','parent','2445670KwxPbx','20xPvJvR','args','autoExpandPropertyCount','unshift','53297','match','_quotedRegExp','angular','data','nan','dockerizedApp',\"/Users/jovitmathew/.vscode/extensions/wallabyjs.console-ninja-1.0.545/node_modules\",'_inNextEdge','stringify','null','pop','reduceOnAccumulatedProcessingTimeMs','_processTreeNodeResult','noFunctions','Number','Set','date','timeStamp','includes','process','port','env','hostname','_addLoadNode','time','logger\\x20failed\\x20to\\x20connect\\x20to\\x20host,\\x20see\\x20','_property','map','number','Promise','value','nodeModules','_treeNodePropertiesAfterFullValue','unref','unknown','[object\\x20Set]','valueOf','replace','_setNodeId','_ws','_allowedToSend','_type','String','Map','concat','default','2544111tDEQCL','_HTMLAllCollection','ws://','6016kOLUTP','edge','bound\\x20Promise','disabledTrace','call','reducedLimits','undefined','_getOwnPropertyDescriptor','_extendedWarning','_sendErrorMessage','7146nZnjWd','perf_hooks','_p_name','osName','_dateToString','bind','expId','index','path','get','log','Console\\x20Ninja\\x20failed\\x20to\\x20send\\x20logs,\\x20restarting\\x20the\\x20process\\x20may\\x20help;\\x20also\\x20see\\x20','import(\\x27url\\x27)','startsWith','toString','resolveGetters','_isMap','_setNodeLabel','_setNodePermissions','toLowerCase','_regExpToString','_isUndefined','autoExpand','','props','reload','trace','isArray','cappedProps','charAt','rootExpression','level','origin','slice','_connected','onclose','forEach','RegExp','1792997237779','_Symbol','object','\\x20server','elapsed','positiveInfinity','setter','%c\\x20Console\\x20Ninja\\x20extension\\x20is\\x20connected\\x20to\\x20','test','_hasSetOnItsPath','modules','send','indexOf','bigint','iterator','631034MBVGic','WebSocket','url','message','_reconnectTimeout','_sortProps','_WebSocketClass','_console_ninja','some','array','onerror','host','prototype','_webSocketErrorDocsLink','_getOwnPropertyNames','count','getOwnPropertySymbols','substr','serialize','gateway.docker.internal','resetWhenQuietMs','5810pOxCld','warn','logger\\x20websocket\\x20error','_blacklistedProperty','_socket','_setNodeQueryPath','current','stackTraceLimit',[\"localhost\",\"127.0.0.1\",\"example.cypress.io\",\"10.0.2.2\",\"Jovits-MacBook-Air.local\",\"192.168.1.25\",\"169.254.224.158\"],'_addFunctionsNode','_setNodeExpandableState','onopen','funcName','ExpoDevice','_allowedToConnectOnSend','coverage','autoExpandLimit','global','hrtime','_addProperty','_capIfString','versions','negativeZero','depth','function','autoExpandPreviousObjects','_cleanNode','_getOwnPropertySymbols','NEXT_RUNTIME','isExpressionToEvaluate','_additionalMetadata','name','_connecting','negativeInfinity','eventReceivedCallback','_inBrowser','58560vpEAXU','HTMLAllCollection','_isNegativeZero','_objectToString','hits','emulator','_isPrimitiveWrapperType','sortProps','remix','','react-native','_undefined','_p_','_isPrimitiveType','getWebSocketClass','defaultLimits','see\\x20https://tinyurl.com/2vt8jxzw\\x20for\\x20more\\x20info.','import(\\x27path\\x27)','_connectToHostNow','toUpperCase','_isSet','_attemptToReconnectShortly','capped','getter','webpack','push','127.0.0.1','_p_length','10.0.2.2','console','autoExpandMaxDepth','now','symbol','length','cappedElements','catch','failed\\x20to\\x20find\\x20and\\x20load\\x20WebSocket','error','perLogpoint','_propertyName','resetOnProcessingTimeAverageMs','_WebSocket','string','_treeNodePropertiesBeforeFullValue','parse','NEGATIVE_INFINITY','then','resolve','421742OoTrcA','ninjaSuppressConsole','_maxConnectAttemptCount','[object\\x20Map]','location','expressionsToEvaluate','type','root_exp_id','reduceLimits','onmessage','[object\\x20Array]','close','reducePolicy','failed\\x20to\\x20connect\\x20to\\x20host:\\x20','stack','_connectAttemptCount','_setNodeExpressionPath','elements','[object\\x20Date]','strLength','352DXVnOa','_hasSymbolPropertyOnItsPath','_disposeWebsocket','next.js','\\x20browser','_consoleNinjaAllowedToStart','_numberRegExp'];_0x5821=function(){return _0x2a97b3;};return _0x5821();}(function(_0x565730,_0xd58451){var _0x3cf7b2=_0x397e,_0x214f86=_0x565730();while(!![]){try{var _0x154707=parseInt(_0x3cf7b2(0x19d))/0x1+parseInt(_0x3cf7b2(0xfd))/0x2+-parseInt(_0x3cf7b2(0x168))/0x3*(-parseInt(_0x3cf7b2(0x111))/0x4)+parseInt(_0x3cf7b2(0x127))/0x5+parseInt(_0x3cf7b2(0xcd))/0x6+parseInt(_0x3cf7b2(0x1b2))/0x7*(-parseInt(_0x3cf7b2(0x15e))/0x8)+-parseInt(_0x3cf7b2(0x15b))/0x9*(parseInt(_0x3cf7b2(0x128))/0xa);if(_0x154707===_0xd58451)break;else _0x214f86['push'](_0x214f86['shift']());}catch(_0xd4cfb7){_0x214f86['push'](_0x214f86['shift']());}}}(_0x5821,0x581c1));function z(_0x86f8f7,_0x4fee50,_0x1d5bdb,_0x33baba,_0xd96feb,_0x49086d){var _0x4bbd34=_0x397e,_0x38d02e,_0x220e13,_0x2e5970,_0x2e5bfb;this[_0x4bbd34(0x1c3)]=_0x86f8f7,this[_0x4bbd34(0x1a8)]=_0x4fee50,this[_0x4bbd34(0x141)]=_0x1d5bdb,this[_0x4bbd34(0x14c)]=_0x33baba,this['dockerizedApp']=_0xd96feb,this[_0x4bbd34(0xcb)]=_0x49086d,this[_0x4bbd34(0x155)]=!0x0,this['_allowedToConnectOnSend']=!0x0,this[_0x4bbd34(0x18a)]=!0x1,this[_0x4bbd34(0xc9)]=!0x1,this[_0x4bbd34(0x134)]=((_0x220e13=(_0x38d02e=_0x86f8f7[_0x4bbd34(0x140)])==null?void 0x0:_0x38d02e[_0x4bbd34(0x142)])==null?void 0x0:_0x220e13[_0x4bbd34(0xc5)])===_0x4bbd34(0x15f),this['_inBrowser']=!((_0x2e5bfb=(_0x2e5970=this[_0x4bbd34(0x1c3)][_0x4bbd34(0x140)])==null?void 0x0:_0x2e5970[_0x4bbd34(0x1c7)])!=null&&_0x2e5bfb[_0x4bbd34(0x125)])&&!this[_0x4bbd34(0x134)],this[_0x4bbd34(0x1a3)]=null,this[_0x4bbd34(0x10c)]=0x0,this[_0x4bbd34(0xff)]=0x14,this['_webSocketErrorDocsLink']='https://tinyurl.com/37x8b79t',this[_0x4bbd34(0x167)]=(this[_0x4bbd34(0xcc)]?'Console\\x20Ninja\\x20failed\\x20to\\x20send\\x20logs,\\x20refreshing\\x20the\\x20page\\x20may\\x20help;\\x20also\\x20see\\x20':_0x4bbd34(0x173))+this[_0x4bbd34(0x1aa)];}function _0x397e(_0x1c242e,_0x583833){var _0x5821dc=_0x5821();return _0x397e=function(_0x397ee4,_0x58096c){_0x397ee4=_0x397ee4-0xbf;var _0xdb08d7=_0x5821dc[_0x397ee4];return _0xdb08d7;},_0x397e(_0x1c242e,_0x583833);}z[_0x34ea16(0x1a9)][_0x34ea16(0xdb)]=async function(){var _0x139cf2=_0x34ea16,_0x5b1792,_0xe960f;if(this[_0x139cf2(0x1a3)])return this[_0x139cf2(0x1a3)];let _0x5e4d80;if(this['_inBrowser']||this[_0x139cf2(0x134)])_0x5e4d80=this['global'][_0x139cf2(0x19e)];else{if((_0x5b1792=this[_0x139cf2(0x1c3)][_0x139cf2(0x140)])!=null&&_0x5b1792['_WebSocket'])_0x5e4d80=(_0xe960f=this[_0x139cf2(0x1c3)][_0x139cf2(0x140)])==null?void 0x0:_0xe960f[_0x139cf2(0xf6)];else try{_0x5e4d80=(await new Function('path',_0x139cf2(0x19f),'nodeModules','return\\x20import(url.pathToFileURL(path.join(nodeModules,\\x20\\x27ws/index.js\\x27)).toString());')(await(0x0,eval)(_0x139cf2(0xde)),await(0x0,eval)(_0x139cf2(0x174)),this[_0x139cf2(0x14c)]))[_0x139cf2(0x15a)];}catch{try{_0x5e4d80=require(require(_0x139cf2(0x170))[_0x139cf2(0x11d)](this[_0x139cf2(0x14c)],'ws'));}catch{throw new Error(_0x139cf2(0xf1));}}}return this['_WebSocketClass']=_0x5e4d80,_0x5e4d80;},z[_0x34ea16(0x1a9)][_0x34ea16(0xdf)]=function(){var _0x221c8f=_0x34ea16;this[_0x221c8f(0xc9)]||this['_connected']||this['_connectAttemptCount']>=this[_0x221c8f(0xff)]||(this[_0x221c8f(0x1c0)]=!0x1,this['_connecting']=!0x0,this[_0x221c8f(0x10c)]++,this[_0x221c8f(0x154)]=new Promise((_0x3564cc,_0xb44c35)=>{var _0xd164e7=_0x221c8f;this['getWebSocketClass']()[_0xd164e7(0xfb)](_0x4c4399=>{var _0x23a5e5=_0xd164e7;let _0x41900b=new _0x4c4399(_0x23a5e5(0x15d)+(!this[_0x23a5e5(0xcc)]&&this[_0x23a5e5(0x132)]?_0x23a5e5(0x1b0):this[_0x23a5e5(0x1a8)])+':'+this[_0x23a5e5(0x141)]);_0x41900b['onerror']=()=>{var _0x5cf063=_0x23a5e5;this[_0x5cf063(0x155)]=!0x1,this[_0x5cf063(0x113)](_0x41900b),this[_0x5cf063(0xe2)](),_0xb44c35(new Error(_0x5cf063(0x1b4)));},_0x41900b[_0x23a5e5(0x1bd)]=()=>{var _0x411009=_0x23a5e5;this[_0x411009(0xcc)]||_0x41900b[_0x411009(0x1b6)]&&_0x41900b['_socket'][_0x411009(0x14e)]&&_0x41900b[_0x411009(0x1b6)][_0x411009(0x14e)](),_0x3564cc(_0x41900b);},_0x41900b[_0x23a5e5(0x18b)]=()=>{var _0x5bee4d=_0x23a5e5;this[_0x5bee4d(0x1c0)]=!0x0,this[_0x5bee4d(0x113)](_0x41900b),this[_0x5bee4d(0xe2)]();},_0x41900b[_0x23a5e5(0x106)]=_0x52dd1e=>{var _0x889f00=_0x23a5e5;try{if(!(_0x52dd1e!=null&&_0x52dd1e[_0x889f00(0x130)])||!this[_0x889f00(0xcb)])return;let _0x549c96=JSON[_0x889f00(0xf9)](_0x52dd1e[_0x889f00(0x130)]);this['eventReceivedCallback'](_0x549c96['method'],_0x549c96[_0x889f00(0x129)],this[_0x889f00(0x1c3)],this[_0x889f00(0xcc)]);}catch{}};})[_0xd164e7(0xfb)](_0x4b4241=>(this[_0xd164e7(0x18a)]=!0x0,this['_connecting']=!0x1,this[_0xd164e7(0x1c0)]=!0x1,this[_0xd164e7(0x155)]=!0x0,this[_0xd164e7(0x10c)]=0x0,_0x4b4241))['catch'](_0x52ca7c=>(this[_0xd164e7(0x18a)]=!0x1,this[_0xd164e7(0xc9)]=!0x1,console['warn'](_0xd164e7(0x146)+this[_0xd164e7(0x1aa)]),_0xb44c35(new Error(_0xd164e7(0x10a)+(_0x52ca7c&&_0x52ca7c[_0xd164e7(0x1a0)])))));}));},z[_0x34ea16(0x1a9)][_0x34ea16(0x113)]=function(_0x52ad38){var _0x3a2d63=_0x34ea16;this[_0x3a2d63(0x18a)]=!0x1,this[_0x3a2d63(0xc9)]=!0x1;try{_0x52ad38[_0x3a2d63(0x18b)]=null,_0x52ad38[_0x3a2d63(0x1a7)]=null,_0x52ad38[_0x3a2d63(0x1bd)]=null;}catch{}try{_0x52ad38[_0x3a2d63(0x122)]<0x2&&_0x52ad38[_0x3a2d63(0x108)]();}catch{}},z[_0x34ea16(0x1a9)][_0x34ea16(0xe2)]=function(){var _0x2c48c1=_0x34ea16;clearTimeout(this['_reconnectTimeout']),!(this['_connectAttemptCount']>=this[_0x2c48c1(0xff)])&&(this['_reconnectTimeout']=setTimeout(()=>{var _0x53f711=_0x2c48c1,_0xd9febc;this[_0x53f711(0x18a)]||this[_0x53f711(0xc9)]||(this[_0x53f711(0xdf)](),(_0xd9febc=this[_0x53f711(0x154)])==null||_0xd9febc[_0x53f711(0xf0)](()=>this[_0x53f711(0xe2)]()));},0x1f4),this[_0x2c48c1(0x1a1)][_0x2c48c1(0x14e)]&&this['_reconnectTimeout'][_0x2c48c1(0x14e)]());},z[_0x34ea16(0x1a9)][_0x34ea16(0x199)]=async function(_0x5c9dc9){var _0x19ef95=_0x34ea16;try{if(!this[_0x19ef95(0x155)])return;this[_0x19ef95(0x1c0)]&&this[_0x19ef95(0xdf)](),(await this[_0x19ef95(0x154)])[_0x19ef95(0x199)](JSON['stringify'](_0x5c9dc9));}catch(_0x3d50b3){this[_0x19ef95(0x166)]?console[_0x19ef95(0x1b3)](this[_0x19ef95(0x167)]+':\\x20'+(_0x3d50b3&&_0x3d50b3[_0x19ef95(0x1a0)])):(this[_0x19ef95(0x166)]=!0x0,console[_0x19ef95(0x1b3)](this[_0x19ef95(0x167)]+':\\x20'+(_0x3d50b3&&_0x3d50b3[_0x19ef95(0x1a0)]),_0x5c9dc9)),this[_0x19ef95(0x155)]=!0x1,this[_0x19ef95(0xe2)]();}};function H(_0x1a31ec,_0xf1a76,_0x1c07b4,_0x3f1aa3,_0xe6c0ce,_0x58420c,_0x2165e4,_0x249512=ne){var _0x182527=_0x34ea16;let _0x2ff53f=_0x1c07b4[_0x182527(0x11b)](',')[_0x182527(0x148)](_0x24d8b5=>{var _0x434e83=_0x182527,_0x1f6264,_0x2357f8,_0xc5fa0d,_0x351a9a,_0x5bda54,_0x51f242,_0x344d6f,_0x3741c3;try{if(!_0x1a31ec[_0x434e83(0x124)]){let _0x1150c5=((_0x2357f8=(_0x1f6264=_0x1a31ec[_0x434e83(0x140)])==null?void 0x0:_0x1f6264[_0x434e83(0x1c7)])==null?void 0x0:_0x2357f8[_0x434e83(0x125)])||((_0x351a9a=(_0xc5fa0d=_0x1a31ec[_0x434e83(0x140)])==null?void 0x0:_0xc5fa0d['env'])==null?void 0x0:_0x351a9a[_0x434e83(0xc5)])===_0x434e83(0x15f);(_0xe6c0ce===_0x434e83(0x114)||_0xe6c0ce===_0x434e83(0xd5)||_0xe6c0ce==='astro'||_0xe6c0ce===_0x434e83(0x12f))&&(_0xe6c0ce+=_0x1150c5?_0x434e83(0x191):_0x434e83(0x115));let _0x383226='';_0xe6c0ce===_0x434e83(0xd7)&&(_0x383226=(((_0x344d6f=(_0x51f242=(_0x5bda54=_0x1a31ec['expo'])==null?void 0x0:_0x5bda54[_0x434e83(0x198)])==null?void 0x0:_0x51f242[_0x434e83(0x1bf)])==null?void 0x0:_0x344d6f[_0x434e83(0x16b)])||_0x434e83(0xd2))[_0x434e83(0x17b)](),_0x383226&&(_0xe6c0ce+='\\x20'+_0x383226,(_0x383226==='android'||_0x383226===_0x434e83(0xd2)&&((_0x3741c3=_0x1a31ec['location'])==null?void 0x0:_0x3741c3[_0x434e83(0x143)])==='10.0.2.2')&&(_0xf1a76=_0x434e83(0xe9)))),_0x1a31ec[_0x434e83(0x124)]={'id':+new Date(),'tool':_0xe6c0ce},_0x2165e4&&_0xe6c0ce&&!_0x1150c5&&(_0x383226?console['log']('Console\\x20Ninja\\x20extension\\x20is\\x20connected\\x20to\\x20'+_0x383226+',\\x20see\\x20https://tinyurl.com/2vt8jxzw\\x20for\\x20more\\x20info.'):console['log'](_0x434e83(0x195)+(_0xe6c0ce[_0x434e83(0x185)](0x0)[_0x434e83(0xe0)]()+_0xe6c0ce[_0x434e83(0x1ae)](0x1))+',','background:\\x20rgb(30,30,30);\\x20color:\\x20rgb(255,213,92)',_0x434e83(0xdd)));}let _0x14ac71=new z(_0x1a31ec,_0xf1a76,_0x24d8b5,_0x3f1aa3,_0x58420c,_0x249512);return _0x14ac71[_0x434e83(0x199)]['bind'](_0x14ac71);}catch(_0xe41c30){return console['warn']('logger\\x20failed\\x20to\\x20connect\\x20to\\x20host',_0xe41c30&&_0xe41c30[_0x434e83(0x1a0)]),()=>{};}});return _0x21cc13=>_0x2ff53f['forEach'](_0x4a212f=>_0x4a212f(_0x21cc13));}function ne(_0x32407b,_0x16adef,_0x4c1ebc,_0x322090){var _0x1679a4=_0x34ea16;_0x322090&&_0x32407b===_0x1679a4(0x181)&&_0x4c1ebc[_0x1679a4(0x101)][_0x1679a4(0x181)]();}function b(_0x78765a){var _0x1da627=_0x34ea16,_0x3db069,_0x1e4e29;let _0x2e8ee4=function(_0x30cc21,_0x4c585d){return _0x4c585d-_0x30cc21;},_0x15e1ae;if(_0x78765a['performance'])_0x15e1ae=function(){var _0x1a97c3=_0x397e;return _0x78765a['performance'][_0x1a97c3(0xec)]();};else{if(_0x78765a[_0x1da627(0x140)]&&_0x78765a[_0x1da627(0x140)]['hrtime']&&((_0x1e4e29=(_0x3db069=_0x78765a[_0x1da627(0x140)])==null?void 0x0:_0x3db069['env'])==null?void 0x0:_0x1e4e29['NEXT_RUNTIME'])!==_0x1da627(0x15f))_0x15e1ae=function(){var _0x2e8e8b=_0x1da627;return _0x78765a[_0x2e8e8b(0x140)][_0x2e8e8b(0x1c4)]();},_0x2e8ee4=function(_0x3180f9,_0x1cdf54){return 0x3e8*(_0x1cdf54[0x0]-_0x3180f9[0x0])+(_0x1cdf54[0x1]-_0x3180f9[0x1])/0xf4240;};else try{let {performance:_0x111e4e}=require(_0x1da627(0x169));_0x15e1ae=function(){var _0xce573f=_0x1da627;return _0x111e4e[_0xce573f(0xec)]();};}catch{_0x15e1ae=function(){return+new Date();};}}return{'elapsed':_0x2e8ee4,'timeStamp':_0x15e1ae,'now':()=>Date[_0x1da627(0xec)]()};}function X(_0x3eae27,_0x36e0f8,_0xc25760){var _0x156f86=_0x34ea16,_0x480f84,_0x5209a7,_0xef0065,_0x489147,_0x44d3b0,_0x46d495,_0x502639;if(_0x3eae27[_0x156f86(0x116)]!==void 0x0)return _0x3eae27[_0x156f86(0x116)];let _0x18611f=((_0x5209a7=(_0x480f84=_0x3eae27['process'])==null?void 0x0:_0x480f84[_0x156f86(0x1c7)])==null?void 0x0:_0x5209a7['node'])||((_0x489147=(_0xef0065=_0x3eae27[_0x156f86(0x140)])==null?void 0x0:_0xef0065[_0x156f86(0x142)])==null?void 0x0:_0x489147[_0x156f86(0xc5)])===_0x156f86(0x15f),_0x2895e1=!!(_0xc25760===_0x156f86(0xd7)&&((_0x44d3b0=_0x3eae27['expo'])==null?void 0x0:_0x44d3b0[_0x156f86(0x198)]));function _0x9884bc(_0x4f4c7c){var _0x5452ae=_0x156f86;if(_0x4f4c7c[_0x5452ae(0x175)]('/')&&_0x4f4c7c['endsWith']('/')){let _0x445d00=new RegExp(_0x4f4c7c[_0x5452ae(0x189)](0x1,-0x1));return _0x522d80=>_0x445d00['test'](_0x522d80);}else{if(_0x4f4c7c[_0x5452ae(0x13f)]('*')||_0x4f4c7c[_0x5452ae(0x13f)]('?')){let _0x3bfa3f=new RegExp('^'+_0x4f4c7c[_0x5452ae(0x152)](/\\./g,String['fromCharCode'](0x5c)+'.')['replace'](/\\*/g,'.*')[_0x5452ae(0x152)](/\\?/g,'.')+String['fromCharCode'](0x24));return _0x2965ec=>_0x3bfa3f[_0x5452ae(0x196)](_0x2965ec);}else return _0x19aa76=>_0x19aa76===_0x4f4c7c;}}let _0x385a18=_0x36e0f8[_0x156f86(0x148)](_0x9884bc);return _0x3eae27[_0x156f86(0x116)]=_0x18611f||!_0x36e0f8,!_0x3eae27[_0x156f86(0x116)]&&((_0x46d495=_0x3eae27[_0x156f86(0x101)])==null?void 0x0:_0x46d495[_0x156f86(0x143)])&&(_0x3eae27[_0x156f86(0x116)]=_0x385a18[_0x156f86(0x1a5)](_0x59b31e=>_0x59b31e(_0x3eae27['location'][_0x156f86(0x143)]))),_0x2895e1&&!_0x3eae27['_consoleNinjaAllowedToStart']&&!((_0x502639=_0x3eae27[_0x156f86(0x101)])!=null&&_0x502639[_0x156f86(0x143)])&&(_0x3eae27[_0x156f86(0x116)]=!0x0),_0x3eae27[_0x156f86(0x116)];}function J(_0x4ef3c2,_0x4eb197,_0x470e69,_0xb46878,_0x33b83c,_0x1850b6){var _0x2d3e35=_0x34ea16;_0x4ef3c2=_0x4ef3c2,_0x4eb197=_0x4eb197,_0x470e69=_0x470e69,_0xb46878=_0xb46878,_0x33b83c=_0x33b83c,_0x33b83c=_0x33b83c||{},_0x33b83c[_0x2d3e35(0xdc)]=_0x33b83c[_0x2d3e35(0xdc)]||{},_0x33b83c[_0x2d3e35(0x163)]=_0x33b83c['reducedLimits']||{},_0x33b83c[_0x2d3e35(0x109)]=_0x33b83c['reducePolicy']||{},_0x33b83c['reducePolicy'][_0x2d3e35(0xf3)]=_0x33b83c[_0x2d3e35(0x109)]['perLogpoint']||{},_0x33b83c['reducePolicy'][_0x2d3e35(0x1c3)]=_0x33b83c['reducePolicy'][_0x2d3e35(0x1c3)]||{};let _0x13b741={'perLogpoint':{'reduceOnCount':_0x33b83c[_0x2d3e35(0x109)][_0x2d3e35(0xf3)]['reduceOnCount']||0x32,'reduceOnAccumulatedProcessingTimeMs':_0x33b83c['reducePolicy']['perLogpoint'][_0x2d3e35(0x138)]||0x64,'resetWhenQuietMs':_0x33b83c['reducePolicy'][_0x2d3e35(0xf3)][_0x2d3e35(0x1b1)]||0x1f4,'resetOnProcessingTimeAverageMs':_0x33b83c['reducePolicy']['perLogpoint']['resetOnProcessingTimeAverageMs']||0x64},'global':{'reduceOnCount':_0x33b83c['reducePolicy'][_0x2d3e35(0x1c3)][_0x2d3e35(0x11f)]||0x3e8,'reduceOnAccumulatedProcessingTimeMs':_0x33b83c[_0x2d3e35(0x109)][_0x2d3e35(0x1c3)][_0x2d3e35(0x138)]||0x12c,'resetWhenQuietMs':_0x33b83c[_0x2d3e35(0x109)][_0x2d3e35(0x1c3)][_0x2d3e35(0x1b1)]||0x32,'resetOnProcessingTimeAverageMs':_0x33b83c[_0x2d3e35(0x109)][_0x2d3e35(0x1c3)][_0x2d3e35(0xf5)]||0x64}},_0xed07fb=b(_0x4ef3c2),_0x4120d1=_0xed07fb[_0x2d3e35(0x192)],_0x594fe3=_0xed07fb[_0x2d3e35(0x13e)];function _0x1583f1(){var _0xf32942=_0x2d3e35;this['_keyStrRegExp']=/^(?!(?:do|if|in|for|let|new|try|var|case|else|enum|eval|false|null|this|true|void|with|break|catch|class|const|super|throw|while|yield|delete|export|import|public|return|static|switch|typeof|default|extends|finally|package|private|continue|debugger|function|arguments|interface|protected|implements|instanceof)$)[_$a-zA-Z\\xA0-\\uFFFF][_$a-zA-Z0-9\\xA0-\\uFFFF]*$/,this[_0xf32942(0x117)]=/^(0|[1-9][0-9]*)$/,this[_0xf32942(0x12e)]=/'([^\\\\']|\\\\')*'/,this[_0xf32942(0xd8)]=_0x4ef3c2[_0xf32942(0x164)],this[_0xf32942(0x15c)]=_0x4ef3c2[_0xf32942(0xce)],this[_0xf32942(0x165)]=Object[_0xf32942(0x11e)],this[_0xf32942(0x1ab)]=Object['getOwnPropertyNames'],this[_0xf32942(0x18f)]=_0x4ef3c2['Symbol'],this[_0xf32942(0x17c)]=RegExp[_0xf32942(0x1a9)][_0xf32942(0x176)],this[_0xf32942(0x16c)]=Date[_0xf32942(0x1a9)][_0xf32942(0x176)];}_0x1583f1[_0x2d3e35(0x1a9)][_0x2d3e35(0x1af)]=function(_0x37d942,_0x1d26f5,_0x4d6a77,_0x41a7e8){var _0x136877=_0x2d3e35,_0x16e8b8=this,_0x1afa4a=_0x4d6a77[_0x136877(0x17e)];function _0x559ba1(_0x192b8a,_0x37d923,_0x579501){var _0x405ab2=_0x136877;_0x37d923[_0x405ab2(0x103)]=_0x405ab2(0x14f),_0x37d923[_0x405ab2(0xf2)]=_0x192b8a['message'],_0x1f9c8f=_0x579501[_0x405ab2(0x125)][_0x405ab2(0x1b8)],_0x579501[_0x405ab2(0x125)]['current']=_0x37d923,_0x16e8b8[_0x405ab2(0xf8)](_0x37d923,_0x579501);}let _0x127081,_0x306ae0,_0x10371b=_0x4ef3c2[_0x136877(0xfe)];_0x4ef3c2[_0x136877(0xfe)]=!0x0,_0x4ef3c2[_0x136877(0xea)]&&(_0x127081=_0x4ef3c2[_0x136877(0xea)][_0x136877(0xf2)],_0x306ae0=_0x4ef3c2[_0x136877(0xea)][_0x136877(0x1b3)],_0x127081&&(_0x4ef3c2[_0x136877(0xea)]['error']=function(){}),_0x306ae0&&(_0x4ef3c2[_0x136877(0xea)][_0x136877(0x1b3)]=function(){}));try{try{_0x4d6a77['level']++,_0x4d6a77[_0x136877(0x17e)]&&_0x4d6a77[_0x136877(0xc2)][_0x136877(0xe6)](_0x1d26f5);var _0x50332b,_0x87d93e,_0x173e43,_0x52beed,_0x4ec178=[],_0x489f5a=[],_0x3fee05,_0x4770cb=this[_0x136877(0x156)](_0x1d26f5),_0x381294=_0x4770cb==='array',_0x79c071=!0x1,_0x12fdeb=_0x4770cb===_0x136877(0xc1),_0x2bffa7=this[_0x136877(0xda)](_0x4770cb),_0x5e08fc=this['_isPrimitiveWrapperType'](_0x4770cb),_0x3a5294=_0x2bffa7||_0x5e08fc,_0x192220={},_0x2e7977=0x0,_0x10a7bb=!0x1,_0x1f9c8f,_0x40d3a3=/^(([1-9]{1}[0-9]*)|0)$/;if(_0x4d6a77['depth']){if(_0x381294){if(_0x87d93e=_0x1d26f5[_0x136877(0xee)],_0x87d93e>_0x4d6a77[_0x136877(0x10e)]){for(_0x173e43=0x0,_0x52beed=_0x4d6a77[_0x136877(0x10e)],_0x50332b=_0x173e43;_0x50332b<_0x52beed;_0x50332b++)_0x489f5a['push'](_0x16e8b8['_addProperty'](_0x4ec178,_0x1d26f5,_0x4770cb,_0x50332b,_0x4d6a77));_0x37d942[_0x136877(0xef)]=!0x0;}else{for(_0x173e43=0x0,_0x52beed=_0x87d93e,_0x50332b=_0x173e43;_0x50332b<_0x52beed;_0x50332b++)_0x489f5a[_0x136877(0xe6)](_0x16e8b8[_0x136877(0x1c5)](_0x4ec178,_0x1d26f5,_0x4770cb,_0x50332b,_0x4d6a77));}_0x4d6a77['autoExpandPropertyCount']+=_0x489f5a['length'];}if(!(_0x4770cb===_0x136877(0x136)||_0x4770cb===_0x136877(0x164))&&!_0x2bffa7&&_0x4770cb!==_0x136877(0x157)&&_0x4770cb!=='Buffer'&&_0x4770cb!==_0x136877(0x19b)){var _0x5b0375=_0x41a7e8[_0x136877(0x180)]||_0x4d6a77[_0x136877(0x180)];if(this[_0x136877(0xe1)](_0x1d26f5)?(_0x50332b=0x0,_0x1d26f5[_0x136877(0x18c)](function(_0x1f0fb1){var _0x36d9f2=_0x136877;if(_0x2e7977++,_0x4d6a77['autoExpandPropertyCount']++,_0x2e7977>_0x5b0375){_0x10a7bb=!0x0;return;}if(!_0x4d6a77[_0x36d9f2(0xc6)]&&_0x4d6a77[_0x36d9f2(0x17e)]&&_0x4d6a77[_0x36d9f2(0x12a)]>_0x4d6a77[_0x36d9f2(0x1c2)]){_0x10a7bb=!0x0;return;}_0x489f5a['push'](_0x16e8b8['_addProperty'](_0x4ec178,_0x1d26f5,_0x36d9f2(0x13c),_0x50332b++,_0x4d6a77,function(_0x3c31e8){return function(){return _0x3c31e8;};}(_0x1f0fb1)));})):this[_0x136877(0x178)](_0x1d26f5)&&_0x1d26f5[_0x136877(0x18c)](function(_0x142bff,_0x47c78f){var _0x3c93fb=_0x136877;if(_0x2e7977++,_0x4d6a77['autoExpandPropertyCount']++,_0x2e7977>_0x5b0375){_0x10a7bb=!0x0;return;}if(!_0x4d6a77[_0x3c93fb(0xc6)]&&_0x4d6a77[_0x3c93fb(0x17e)]&&_0x4d6a77[_0x3c93fb(0x12a)]>_0x4d6a77[_0x3c93fb(0x1c2)]){_0x10a7bb=!0x0;return;}var _0x331ed7=_0x47c78f[_0x3c93fb(0x176)]();_0x331ed7['length']>0x64&&(_0x331ed7=_0x331ed7[_0x3c93fb(0x189)](0x0,0x64)+'...'),_0x489f5a['push'](_0x16e8b8[_0x3c93fb(0x1c5)](_0x4ec178,_0x1d26f5,_0x3c93fb(0x158),_0x331ed7,_0x4d6a77,function(_0x3f00e2){return function(){return _0x3f00e2;};}(_0x142bff)));}),!_0x79c071){try{for(_0x3fee05 in _0x1d26f5)if(!(_0x381294&&_0x40d3a3[_0x136877(0x196)](_0x3fee05))&&!this[_0x136877(0x1b5)](_0x1d26f5,_0x3fee05,_0x4d6a77)){if(_0x2e7977++,_0x4d6a77[_0x136877(0x12a)]++,_0x2e7977>_0x5b0375){_0x10a7bb=!0x0;break;}if(!_0x4d6a77['isExpressionToEvaluate']&&_0x4d6a77[_0x136877(0x17e)]&&_0x4d6a77[_0x136877(0x12a)]>_0x4d6a77[_0x136877(0x1c2)]){_0x10a7bb=!0x0;break;}_0x489f5a[_0x136877(0xe6)](_0x16e8b8[_0x136877(0x119)](_0x4ec178,_0x192220,_0x1d26f5,_0x4770cb,_0x3fee05,_0x4d6a77));}}catch{}if(_0x192220[_0x136877(0xe8)]=!0x0,_0x12fdeb&&(_0x192220[_0x136877(0x16a)]=!0x0),!_0x10a7bb){var _0x5b13a1=[][_0x136877(0x159)](this[_0x136877(0x1ab)](_0x1d26f5))['concat'](this[_0x136877(0xc4)](_0x1d26f5));for(_0x50332b=0x0,_0x87d93e=_0x5b13a1['length'];_0x50332b<_0x87d93e;_0x50332b++)if(_0x3fee05=_0x5b13a1[_0x50332b],!(_0x381294&&_0x40d3a3[_0x136877(0x196)](_0x3fee05[_0x136877(0x176)]()))&&!this[_0x136877(0x1b5)](_0x1d26f5,_0x3fee05,_0x4d6a77)&&!_0x192220[typeof _0x3fee05!=_0x136877(0xed)?_0x136877(0xd9)+_0x3fee05[_0x136877(0x176)]():_0x3fee05]){if(_0x2e7977++,_0x4d6a77['autoExpandPropertyCount']++,_0x2e7977>_0x5b0375){_0x10a7bb=!0x0;break;}if(!_0x4d6a77['isExpressionToEvaluate']&&_0x4d6a77['autoExpand']&&_0x4d6a77[_0x136877(0x12a)]>_0x4d6a77[_0x136877(0x1c2)]){_0x10a7bb=!0x0;break;}_0x489f5a['push'](_0x16e8b8[_0x136877(0x119)](_0x4ec178,_0x192220,_0x1d26f5,_0x4770cb,_0x3fee05,_0x4d6a77));}}}}}if(_0x37d942[_0x136877(0x103)]=_0x4770cb,_0x3a5294?(_0x37d942[_0x136877(0x14b)]=_0x1d26f5[_0x136877(0x151)](),this[_0x136877(0x1c6)](_0x4770cb,_0x37d942,_0x4d6a77,_0x41a7e8)):_0x4770cb===_0x136877(0x13d)?_0x37d942[_0x136877(0x14b)]=this['_dateToString']['call'](_0x1d26f5):_0x4770cb==='bigint'?_0x37d942[_0x136877(0x14b)]=_0x1d26f5[_0x136877(0x176)]():_0x4770cb===_0x136877(0x18d)?_0x37d942[_0x136877(0x14b)]=this[_0x136877(0x17c)]['call'](_0x1d26f5):_0x4770cb===_0x136877(0xed)&&this[_0x136877(0x18f)]?_0x37d942[_0x136877(0x14b)]=this[_0x136877(0x18f)][_0x136877(0x1a9)][_0x136877(0x176)][_0x136877(0x162)](_0x1d26f5):!_0x4d6a77[_0x136877(0xc0)]&&!(_0x4770cb===_0x136877(0x136)||_0x4770cb===_0x136877(0x164))&&(delete _0x37d942[_0x136877(0x14b)],_0x37d942[_0x136877(0xe3)]=!0x0),_0x10a7bb&&(_0x37d942[_0x136877(0x184)]=!0x0),_0x1f9c8f=_0x4d6a77['node'][_0x136877(0x1b8)],_0x4d6a77[_0x136877(0x125)]['current']=_0x37d942,this['_treeNodePropertiesBeforeFullValue'](_0x37d942,_0x4d6a77),_0x489f5a[_0x136877(0xee)]){for(_0x50332b=0x0,_0x87d93e=_0x489f5a['length'];_0x50332b<_0x87d93e;_0x50332b++)_0x489f5a[_0x50332b](_0x50332b);}_0x4ec178['length']&&(_0x37d942[_0x136877(0x180)]=_0x4ec178);}catch(_0x1ba7c5){_0x559ba1(_0x1ba7c5,_0x37d942,_0x4d6a77);}this[_0x136877(0xc7)](_0x1d26f5,_0x37d942),this[_0x136877(0x14d)](_0x37d942,_0x4d6a77),_0x4d6a77[_0x136877(0x125)]['current']=_0x1f9c8f,_0x4d6a77[_0x136877(0x187)]--,_0x4d6a77[_0x136877(0x17e)]=_0x1afa4a,_0x4d6a77['autoExpand']&&_0x4d6a77[_0x136877(0xc2)][_0x136877(0x137)]();}finally{_0x127081&&(_0x4ef3c2[_0x136877(0xea)][_0x136877(0xf2)]=_0x127081),_0x306ae0&&(_0x4ef3c2[_0x136877(0xea)][_0x136877(0x1b3)]=_0x306ae0),_0x4ef3c2[_0x136877(0xfe)]=_0x10371b;}return _0x37d942;},_0x1583f1[_0x2d3e35(0x1a9)][_0x2d3e35(0xc4)]=function(_0x53499a){var _0x15da05=_0x2d3e35;return Object[_0x15da05(0x1ad)]?Object['getOwnPropertySymbols'](_0x53499a):[];},_0x1583f1[_0x2d3e35(0x1a9)][_0x2d3e35(0xe1)]=function(_0x327333){var _0x363956=_0x2d3e35;return!!(_0x327333&&_0x4ef3c2[_0x363956(0x13c)]&&this['_objectToString'](_0x327333)===_0x363956(0x150)&&_0x327333[_0x363956(0x18c)]);},_0x1583f1[_0x2d3e35(0x1a9)][_0x2d3e35(0x1b5)]=function(_0x4d706b,_0x44b009,_0x55e35b){var _0x210c88=_0x2d3e35;if(!_0x55e35b['resolveGetters']){let _0x1fc869=this[_0x210c88(0x165)](_0x4d706b,_0x44b009);if(_0x1fc869&&_0x1fc869[_0x210c88(0x171)])return!0x0;}return _0x55e35b[_0x210c88(0x13a)]?typeof _0x4d706b[_0x44b009]=='function':!0x1;},_0x1583f1[_0x2d3e35(0x1a9)][_0x2d3e35(0x156)]=function(_0x1be33b){var _0x1ce0bf=_0x2d3e35,_0x23767c='';return _0x23767c=typeof _0x1be33b,_0x23767c===_0x1ce0bf(0x190)?this[_0x1ce0bf(0xd0)](_0x1be33b)==='[object\\x20Array]'?_0x23767c='array':this[_0x1ce0bf(0xd0)](_0x1be33b)===_0x1ce0bf(0x10f)?_0x23767c=_0x1ce0bf(0x13d):this[_0x1ce0bf(0xd0)](_0x1be33b)==='[object\\x20BigInt]'?_0x23767c='bigint':_0x1be33b===null?_0x23767c=_0x1ce0bf(0x136):_0x1be33b['constructor']&&(_0x23767c=_0x1be33b['constructor'][_0x1ce0bf(0xc8)]||_0x23767c):_0x23767c==='undefined'&&this[_0x1ce0bf(0x15c)]&&_0x1be33b instanceof this[_0x1ce0bf(0x15c)]&&(_0x23767c='HTMLAllCollection'),_0x23767c;},_0x1583f1[_0x2d3e35(0x1a9)]['_objectToString']=function(_0x354fe6){var _0x44128c=_0x2d3e35;return Object[_0x44128c(0x1a9)][_0x44128c(0x176)][_0x44128c(0x162)](_0x354fe6);},_0x1583f1['prototype'][_0x2d3e35(0xda)]=function(_0x3d1ae4){var _0xbd4748=_0x2d3e35;return _0x3d1ae4===_0xbd4748(0x120)||_0x3d1ae4===_0xbd4748(0xf7)||_0x3d1ae4==='number';},_0x1583f1['prototype'][_0x2d3e35(0xd3)]=function(_0x412adf){var _0x29bd86=_0x2d3e35;return _0x412adf==='Boolean'||_0x412adf===_0x29bd86(0x157)||_0x412adf===_0x29bd86(0x13b);},_0x1583f1[_0x2d3e35(0x1a9)]['_addProperty']=function(_0x2079bd,_0x4c4a98,_0x3cda04,_0x5218de,_0x270678,_0x32fef1){var _0x100c4c=this;return function(_0x2eeb60){var _0x24e956=_0x397e,_0x16d835=_0x270678[_0x24e956(0x125)][_0x24e956(0x1b8)],_0x47fa7a=_0x270678['node'][_0x24e956(0x16f)],_0x283ae8=_0x270678[_0x24e956(0x125)][_0x24e956(0x126)];_0x270678[_0x24e956(0x125)][_0x24e956(0x126)]=_0x16d835,_0x270678['node']['index']=typeof _0x5218de==_0x24e956(0x149)?_0x5218de:_0x2eeb60,_0x2079bd[_0x24e956(0xe6)](_0x100c4c[_0x24e956(0x147)](_0x4c4a98,_0x3cda04,_0x5218de,_0x270678,_0x32fef1)),_0x270678['node']['parent']=_0x283ae8,_0x270678['node'][_0x24e956(0x16f)]=_0x47fa7a;};},_0x1583f1['prototype'][_0x2d3e35(0x119)]=function(_0x3dfa6e,_0x29f5b9,_0x39e96a,_0x182f0e,_0x131285,_0x10589a,_0xcac687){var _0x31ac0d=_0x2d3e35,_0x56994f=this;return _0x29f5b9[typeof _0x131285!=_0x31ac0d(0xed)?_0x31ac0d(0xd9)+_0x131285[_0x31ac0d(0x176)]():_0x131285]=!0x0,function(_0x1de9f9){var _0xaeb905=_0x31ac0d,_0x7686e8=_0x10589a[_0xaeb905(0x125)][_0xaeb905(0x1b8)],_0x266d8e=_0x10589a[_0xaeb905(0x125)][_0xaeb905(0x16f)],_0xec6ea8=_0x10589a['node'][_0xaeb905(0x126)];_0x10589a['node'][_0xaeb905(0x126)]=_0x7686e8,_0x10589a[_0xaeb905(0x125)]['index']=_0x1de9f9,_0x3dfa6e['push'](_0x56994f['_property'](_0x39e96a,_0x182f0e,_0x131285,_0x10589a,_0xcac687)),_0x10589a[_0xaeb905(0x125)][_0xaeb905(0x126)]=_0xec6ea8,_0x10589a[_0xaeb905(0x125)][_0xaeb905(0x16f)]=_0x266d8e;};},_0x1583f1[_0x2d3e35(0x1a9)][_0x2d3e35(0x147)]=function(_0x106c3b,_0x3521d4,_0x105c34,_0x29c8c1,_0x5b186f){var _0x3fce09=_0x2d3e35,_0x434381=this;_0x5b186f||(_0x5b186f=function(_0x42b7e9,_0x38cf7e){return _0x42b7e9[_0x38cf7e];});var _0x56afac=_0x105c34[_0x3fce09(0x176)](),_0x54da9a=_0x29c8c1[_0x3fce09(0x102)]||{},_0xd88c81=_0x29c8c1[_0x3fce09(0xc0)],_0x4bd0f8=_0x29c8c1['isExpressionToEvaluate'];try{var _0x459dc9=this[_0x3fce09(0x178)](_0x106c3b),_0x1ed3a9=_0x56afac;_0x459dc9&&_0x1ed3a9[0x0]==='\\x27'&&(_0x1ed3a9=_0x1ed3a9[_0x3fce09(0x1ae)](0x1,_0x1ed3a9[_0x3fce09(0xee)]-0x2));var _0x9a0801=_0x29c8c1[_0x3fce09(0x102)]=_0x54da9a[_0x3fce09(0xd9)+_0x1ed3a9];_0x9a0801&&(_0x29c8c1[_0x3fce09(0xc0)]=_0x29c8c1[_0x3fce09(0xc0)]+0x1),_0x29c8c1['isExpressionToEvaluate']=!!_0x9a0801;var _0x4e90fc=typeof _0x105c34==_0x3fce09(0xed),_0x5a3dc4={'name':_0x4e90fc||_0x459dc9?_0x56afac:this[_0x3fce09(0xf4)](_0x56afac)};if(_0x4e90fc&&(_0x5a3dc4[_0x3fce09(0xed)]=!0x0),!(_0x3521d4===_0x3fce09(0x1a6)||_0x3521d4==='Error')){var _0x516fff=this[_0x3fce09(0x165)](_0x106c3b,_0x105c34);if(_0x516fff&&(_0x516fff['set']&&(_0x5a3dc4[_0x3fce09(0x194)]=!0x0),_0x516fff[_0x3fce09(0x171)]&&!_0x9a0801&&!_0x29c8c1[_0x3fce09(0x177)]))return _0x5a3dc4[_0x3fce09(0xe4)]=!0x0,this[_0x3fce09(0x139)](_0x5a3dc4,_0x29c8c1),_0x5a3dc4;}var _0x3652c9;try{_0x3652c9=_0x5b186f(_0x106c3b,_0x105c34);}catch(_0x22ea8e){return _0x5a3dc4={'name':_0x56afac,'type':_0x3fce09(0x14f),'error':_0x22ea8e[_0x3fce09(0x1a0)]},this['_processTreeNodeResult'](_0x5a3dc4,_0x29c8c1),_0x5a3dc4;}var _0x3aa073=this[_0x3fce09(0x156)](_0x3652c9),_0x4d7396=this[_0x3fce09(0xda)](_0x3aa073);if(_0x5a3dc4[_0x3fce09(0x103)]=_0x3aa073,_0x4d7396)this[_0x3fce09(0x139)](_0x5a3dc4,_0x29c8c1,_0x3652c9,function(){var _0x3c78fd=_0x3fce09;_0x5a3dc4[_0x3c78fd(0x14b)]=_0x3652c9[_0x3c78fd(0x151)](),!_0x9a0801&&_0x434381[_0x3c78fd(0x1c6)](_0x3aa073,_0x5a3dc4,_0x29c8c1,{});});else{var _0x43bccc=_0x29c8c1['autoExpand']&&_0x29c8c1[_0x3fce09(0x187)]<_0x29c8c1[_0x3fce09(0xeb)]&&_0x29c8c1['autoExpandPreviousObjects'][_0x3fce09(0x19a)](_0x3652c9)<0x0&&_0x3aa073!==_0x3fce09(0xc1)&&_0x29c8c1[_0x3fce09(0x12a)]<_0x29c8c1[_0x3fce09(0x1c2)];_0x43bccc||_0x29c8c1['level']<_0xd88c81||_0x9a0801?this[_0x3fce09(0x1af)](_0x5a3dc4,_0x3652c9,_0x29c8c1,_0x9a0801||{}):this['_processTreeNodeResult'](_0x5a3dc4,_0x29c8c1,_0x3652c9,function(){var _0x561fdc=_0x3fce09;_0x3aa073===_0x561fdc(0x136)||_0x3aa073===_0x561fdc(0x164)||(delete _0x5a3dc4['value'],_0x5a3dc4[_0x561fdc(0xe3)]=!0x0);});}return _0x5a3dc4;}finally{_0x29c8c1['expressionsToEvaluate']=_0x54da9a,_0x29c8c1['depth']=_0xd88c81,_0x29c8c1[_0x3fce09(0xc6)]=_0x4bd0f8;}},_0x1583f1[_0x2d3e35(0x1a9)][_0x2d3e35(0x1c6)]=function(_0x1f19c1,_0x3fe20e,_0x5a4406,_0x6752d5){var _0x2315ed=_0x2d3e35,_0x3b9e77=_0x6752d5['strLength']||_0x5a4406[_0x2315ed(0x110)];if((_0x1f19c1===_0x2315ed(0xf7)||_0x1f19c1===_0x2315ed(0x157))&&_0x3fe20e[_0x2315ed(0x14b)]){let _0x1be3d9=_0x3fe20e[_0x2315ed(0x14b)][_0x2315ed(0xee)];_0x5a4406[_0x2315ed(0x121)]+=_0x1be3d9,_0x5a4406[_0x2315ed(0x121)]>_0x5a4406['totalStrLength']?(_0x3fe20e[_0x2315ed(0xe3)]='',delete _0x3fe20e[_0x2315ed(0x14b)]):_0x1be3d9>_0x3b9e77&&(_0x3fe20e[_0x2315ed(0xe3)]=_0x3fe20e[_0x2315ed(0x14b)][_0x2315ed(0x1ae)](0x0,_0x3b9e77),delete _0x3fe20e['value']);}},_0x1583f1['prototype'][_0x2d3e35(0x178)]=function(_0x36ba81){var _0x23d5f7=_0x2d3e35;return!!(_0x36ba81&&_0x4ef3c2[_0x23d5f7(0x158)]&&this[_0x23d5f7(0xd0)](_0x36ba81)===_0x23d5f7(0x100)&&_0x36ba81[_0x23d5f7(0x18c)]);},_0x1583f1[_0x2d3e35(0x1a9)][_0x2d3e35(0xf4)]=function(_0x7599c7){var _0x278d14=_0x2d3e35;if(_0x7599c7[_0x278d14(0x12d)](/^\\d+$/))return _0x7599c7;var _0x130d11;try{_0x130d11=JSON[_0x278d14(0x135)](''+_0x7599c7);}catch{_0x130d11='\\x22'+this['_objectToString'](_0x7599c7)+'\\x22';}return _0x130d11[_0x278d14(0x12d)](/^\"([a-zA-Z_][a-zA-Z_0-9]*)\"$/)?_0x130d11=_0x130d11[_0x278d14(0x1ae)](0x1,_0x130d11['length']-0x2):_0x130d11=_0x130d11[_0x278d14(0x152)](/'/g,'\\x5c\\x27')['replace'](/\\\\\"/g,'\\x22')['replace'](/(^\"|\"$)/g,'\\x27'),_0x130d11;},_0x1583f1[_0x2d3e35(0x1a9)]['_processTreeNodeResult']=function(_0x1e17c6,_0x4dbf7a,_0x55968b,_0x4d38c){var _0x5838cb=_0x2d3e35;this[_0x5838cb(0xf8)](_0x1e17c6,_0x4dbf7a),_0x4d38c&&_0x4d38c(),this[_0x5838cb(0xc7)](_0x55968b,_0x1e17c6),this['_treeNodePropertiesAfterFullValue'](_0x1e17c6,_0x4dbf7a);},_0x1583f1[_0x2d3e35(0x1a9)][_0x2d3e35(0xf8)]=function(_0x749f4b,_0x77ab32){var _0x6f4df7=_0x2d3e35;this[_0x6f4df7(0x153)](_0x749f4b,_0x77ab32),this['_setNodeQueryPath'](_0x749f4b,_0x77ab32),this[_0x6f4df7(0x10d)](_0x749f4b,_0x77ab32),this['_setNodePermissions'](_0x749f4b,_0x77ab32);},_0x1583f1[_0x2d3e35(0x1a9)][_0x2d3e35(0x153)]=function(_0x521424,_0x45325e){},_0x1583f1['prototype'][_0x2d3e35(0x1b7)]=function(_0x65a88e,_0x2f87ce){},_0x1583f1[_0x2d3e35(0x1a9)][_0x2d3e35(0x179)]=function(_0x3cc042,_0x145e0d){},_0x1583f1[_0x2d3e35(0x1a9)][_0x2d3e35(0x17d)]=function(_0xe3db36){return _0xe3db36===this['_undefined'];},_0x1583f1[_0x2d3e35(0x1a9)]['_treeNodePropertiesAfterFullValue']=function(_0x280c79,_0x38fd98){var _0x1a82b0=_0x2d3e35;this[_0x1a82b0(0x179)](_0x280c79,_0x38fd98),this[_0x1a82b0(0x1bc)](_0x280c79),_0x38fd98['sortProps']&&this['_sortProps'](_0x280c79),this['_addFunctionsNode'](_0x280c79,_0x38fd98),this[_0x1a82b0(0x144)](_0x280c79,_0x38fd98),this['_cleanNode'](_0x280c79);},_0x1583f1[_0x2d3e35(0x1a9)][_0x2d3e35(0xc7)]=function(_0x26d9a5,_0x2b1786){var _0x589a97=_0x2d3e35;try{_0x26d9a5&&typeof _0x26d9a5['length']==_0x589a97(0x149)&&(_0x2b1786[_0x589a97(0xee)]=_0x26d9a5[_0x589a97(0xee)]);}catch{}if(_0x2b1786[_0x589a97(0x103)]===_0x589a97(0x149)||_0x2b1786['type']==='Number'){if(isNaN(_0x2b1786['value']))_0x2b1786[_0x589a97(0x131)]=!0x0,delete _0x2b1786[_0x589a97(0x14b)];else switch(_0x2b1786[_0x589a97(0x14b)]){case Number[_0x589a97(0x123)]:_0x2b1786[_0x589a97(0x193)]=!0x0,delete _0x2b1786[_0x589a97(0x14b)];break;case Number[_0x589a97(0xfa)]:_0x2b1786[_0x589a97(0xca)]=!0x0,delete _0x2b1786[_0x589a97(0x14b)];break;case 0x0:this[_0x589a97(0xcf)](_0x2b1786[_0x589a97(0x14b)])&&(_0x2b1786[_0x589a97(0xbf)]=!0x0);break;}}else _0x2b1786[_0x589a97(0x103)]===_0x589a97(0xc1)&&typeof _0x26d9a5['name']==_0x589a97(0xf7)&&_0x26d9a5['name']&&_0x2b1786[_0x589a97(0xc8)]&&_0x26d9a5[_0x589a97(0xc8)]!==_0x2b1786[_0x589a97(0xc8)]&&(_0x2b1786[_0x589a97(0x1be)]=_0x26d9a5['name']);},_0x1583f1['prototype'][_0x2d3e35(0xcf)]=function(_0xaf9090){var _0x2180fd=_0x2d3e35;return 0x1/_0xaf9090===Number[_0x2180fd(0xfa)];},_0x1583f1[_0x2d3e35(0x1a9)][_0x2d3e35(0x1a2)]=function(_0x4be9f1){var _0x3573aa=_0x2d3e35;!_0x4be9f1[_0x3573aa(0x180)]||!_0x4be9f1[_0x3573aa(0x180)][_0x3573aa(0xee)]||_0x4be9f1[_0x3573aa(0x103)]===_0x3573aa(0x1a6)||_0x4be9f1[_0x3573aa(0x103)]===_0x3573aa(0x158)||_0x4be9f1[_0x3573aa(0x103)]===_0x3573aa(0x13c)||_0x4be9f1[_0x3573aa(0x180)]['sort'](function(_0x4088c4,_0x272e5e){var _0x34339b=_0x3573aa,_0x4deb33=_0x4088c4[_0x34339b(0xc8)][_0x34339b(0x17b)](),_0x2d4fcd=_0x272e5e[_0x34339b(0xc8)][_0x34339b(0x17b)]();return _0x4deb33<_0x2d4fcd?-0x1:_0x4deb33>_0x2d4fcd?0x1:0x0;});},_0x1583f1['prototype'][_0x2d3e35(0x1bb)]=function(_0x7c682c,_0xc5d35e){var _0x1da479=_0x2d3e35;if(!(_0xc5d35e[_0x1da479(0x13a)]||!_0x7c682c[_0x1da479(0x180)]||!_0x7c682c[_0x1da479(0x180)][_0x1da479(0xee)])){for(var _0x51abfa=[],_0x34e082=[],_0x2ebf16=0x0,_0x19caa3=_0x7c682c[_0x1da479(0x180)][_0x1da479(0xee)];_0x2ebf16<_0x19caa3;_0x2ebf16++){var _0x2cb464=_0x7c682c[_0x1da479(0x180)][_0x2ebf16];_0x2cb464[_0x1da479(0x103)]===_0x1da479(0xc1)?_0x51abfa[_0x1da479(0xe6)](_0x2cb464):_0x34e082['push'](_0x2cb464);}if(!(!_0x34e082[_0x1da479(0xee)]||_0x51abfa['length']<=0x1)){_0x7c682c['props']=_0x34e082;var _0x58a293={'functionsNode':!0x0,'props':_0x51abfa};this[_0x1da479(0x153)](_0x58a293,_0xc5d35e),this[_0x1da479(0x179)](_0x58a293,_0xc5d35e),this[_0x1da479(0x1bc)](_0x58a293),this[_0x1da479(0x17a)](_0x58a293,_0xc5d35e),_0x58a293['id']+='\\x20f',_0x7c682c['props'][_0x1da479(0x12b)](_0x58a293);}}},_0x1583f1[_0x2d3e35(0x1a9)]['_addLoadNode']=function(_0x57dac9,_0x503e93){},_0x1583f1[_0x2d3e35(0x1a9)][_0x2d3e35(0x1bc)]=function(_0x5cfa22){},_0x1583f1[_0x2d3e35(0x1a9)]['_isArray']=function(_0x3ae020){var _0xea91ce=_0x2d3e35;return Array[_0xea91ce(0x183)](_0x3ae020)||typeof _0x3ae020=='object'&&this[_0xea91ce(0xd0)](_0x3ae020)===_0xea91ce(0x107);},_0x1583f1[_0x2d3e35(0x1a9)][_0x2d3e35(0x17a)]=function(_0x4bd386,_0x39eb82){},_0x1583f1['prototype'][_0x2d3e35(0xc3)]=function(_0x3ee547){var _0x18d945=_0x2d3e35;delete _0x3ee547[_0x18d945(0x112)],delete _0x3ee547[_0x18d945(0x197)],delete _0x3ee547['_hasMapOnItsPath'];},_0x1583f1[_0x2d3e35(0x1a9)][_0x2d3e35(0x10d)]=function(_0x4ae76c,_0x3614a7){};let _0x1cd003=new _0x1583f1(),_0x35f2a4={'props':_0x33b83c['defaultLimits'][_0x2d3e35(0x180)]||0x64,'elements':_0x33b83c[_0x2d3e35(0xdc)][_0x2d3e35(0x10e)]||0x64,'strLength':_0x33b83c[_0x2d3e35(0xdc)][_0x2d3e35(0x110)]||0x400*0x32,'totalStrLength':_0x33b83c['defaultLimits'][_0x2d3e35(0x11c)]||0x400*0x32,'autoExpandLimit':_0x33b83c[_0x2d3e35(0xdc)][_0x2d3e35(0x1c2)]||0x1388,'autoExpandMaxDepth':_0x33b83c['defaultLimits']['autoExpandMaxDepth']||0xa},_0x4f2d54={'props':_0x33b83c['reducedLimits'][_0x2d3e35(0x180)]||0x5,'elements':_0x33b83c[_0x2d3e35(0x163)][_0x2d3e35(0x10e)]||0x5,'strLength':_0x33b83c[_0x2d3e35(0x163)][_0x2d3e35(0x110)]||0x100,'totalStrLength':_0x33b83c[_0x2d3e35(0x163)][_0x2d3e35(0x11c)]||0x100*0x3,'autoExpandLimit':_0x33b83c[_0x2d3e35(0x163)][_0x2d3e35(0x1c2)]||0x1e,'autoExpandMaxDepth':_0x33b83c[_0x2d3e35(0x163)][_0x2d3e35(0xeb)]||0x2};if(_0x1850b6){let _0x1ed37f=_0x1cd003[_0x2d3e35(0x1af)][_0x2d3e35(0x16d)](_0x1cd003);_0x1cd003['serialize']=function(_0x20b9e3,_0xde4523,_0x6dfb6e,_0x45b9d8){return _0x1ed37f(_0x20b9e3,_0x1850b6(_0xde4523),_0x6dfb6e,_0x45b9d8);};}function _0x853c2d(_0x19de88,_0x92ffd3,_0x1d67ec,_0x3c0439,_0x2c965c,_0x5f0da7){var _0x91f555=_0x2d3e35;let _0x28659b,_0x1bec47;try{_0x1bec47=_0x594fe3(),_0x28659b=_0x470e69[_0x92ffd3],!_0x28659b||_0x1bec47-_0x28659b['ts']>_0x13b741[_0x91f555(0xf3)]['resetWhenQuietMs']&&_0x28659b['count']&&_0x28659b[_0x91f555(0x145)]/_0x28659b[_0x91f555(0x1ac)]<_0x13b741[_0x91f555(0xf3)][_0x91f555(0xf5)]?(_0x470e69[_0x92ffd3]=_0x28659b={'count':0x0,'time':0x0,'ts':_0x1bec47},_0x470e69['hits']={}):_0x1bec47-_0x470e69['hits']['ts']>_0x13b741[_0x91f555(0x1c3)][_0x91f555(0x1b1)]&&_0x470e69[_0x91f555(0xd1)]['count']&&_0x470e69[_0x91f555(0xd1)][_0x91f555(0x145)]/_0x470e69['hits']['count']<_0x13b741[_0x91f555(0x1c3)]['resetOnProcessingTimeAverageMs']&&(_0x470e69[_0x91f555(0xd1)]={});let _0x4b3ded=[],_0x506fb2=_0x28659b['reduceLimits']||_0x470e69[_0x91f555(0xd1)][_0x91f555(0x105)]?_0x4f2d54:_0x35f2a4,_0x48c9a7=_0x484e73=>{var _0x3afe8d=_0x91f555;let _0x21d1e7={};return _0x21d1e7[_0x3afe8d(0x180)]=_0x484e73[_0x3afe8d(0x180)],_0x21d1e7[_0x3afe8d(0x10e)]=_0x484e73[_0x3afe8d(0x10e)],_0x21d1e7['strLength']=_0x484e73[_0x3afe8d(0x110)],_0x21d1e7[_0x3afe8d(0x11c)]=_0x484e73[_0x3afe8d(0x11c)],_0x21d1e7[_0x3afe8d(0x1c2)]=_0x484e73['autoExpandLimit'],_0x21d1e7[_0x3afe8d(0xeb)]=_0x484e73[_0x3afe8d(0xeb)],_0x21d1e7[_0x3afe8d(0xd4)]=!0x1,_0x21d1e7['noFunctions']=!_0x4eb197,_0x21d1e7['depth']=0x1,_0x21d1e7['level']=0x0,_0x21d1e7[_0x3afe8d(0x16e)]=_0x3afe8d(0x104),_0x21d1e7[_0x3afe8d(0x186)]='root_exp',_0x21d1e7[_0x3afe8d(0x17e)]=!0x0,_0x21d1e7[_0x3afe8d(0xc2)]=[],_0x21d1e7[_0x3afe8d(0x12a)]=0x0,_0x21d1e7[_0x3afe8d(0x177)]=_0x33b83c['resolveGetters'],_0x21d1e7[_0x3afe8d(0x121)]=0x0,_0x21d1e7[_0x3afe8d(0x125)]={'current':void 0x0,'parent':void 0x0,'index':0x0},_0x21d1e7;};for(var _0x4e686f=0x0;_0x4e686f<_0x2c965c['length'];_0x4e686f++)_0x4b3ded[_0x91f555(0xe6)](_0x1cd003[_0x91f555(0x1af)]({'timeNode':_0x19de88===_0x91f555(0x145)||void 0x0},_0x2c965c[_0x4e686f],_0x48c9a7(_0x506fb2),{}));if(_0x19de88===_0x91f555(0x182)||_0x19de88==='error'){let _0x5e46b1=Error[_0x91f555(0x1b9)];try{Error[_0x91f555(0x1b9)]=0x1/0x0,_0x4b3ded['push'](_0x1cd003['serialize']({'stackNode':!0x0},new Error()[_0x91f555(0x10b)],_0x48c9a7(_0x506fb2),{'strLength':0x1/0x0}));}finally{Error[_0x91f555(0x1b9)]=_0x5e46b1;}}return{'method':'log','version':_0xb46878,'args':[{'ts':_0x1d67ec,'session':_0x3c0439,'args':_0x4b3ded,'id':_0x92ffd3,'context':_0x5f0da7}]};}catch(_0x51d222){return{'method':_0x91f555(0x172),'version':_0xb46878,'args':[{'ts':_0x1d67ec,'session':_0x3c0439,'args':[{'type':_0x91f555(0x14f),'error':_0x51d222&&_0x51d222[_0x91f555(0x1a0)]}],'id':_0x92ffd3,'context':_0x5f0da7}]};}finally{try{if(_0x28659b&&_0x1bec47){let _0x3f4e88=_0x594fe3();_0x28659b[_0x91f555(0x1ac)]++,_0x28659b[_0x91f555(0x145)]+=_0x4120d1(_0x1bec47,_0x3f4e88),_0x28659b['ts']=_0x3f4e88,_0x470e69['hits'][_0x91f555(0x1ac)]++,_0x470e69[_0x91f555(0xd1)][_0x91f555(0x145)]+=_0x4120d1(_0x1bec47,_0x3f4e88),_0x470e69['hits']['ts']=_0x3f4e88,(_0x28659b[_0x91f555(0x1ac)]>_0x13b741[_0x91f555(0xf3)][_0x91f555(0x11f)]||_0x28659b[_0x91f555(0x145)]>_0x13b741[_0x91f555(0xf3)][_0x91f555(0x138)])&&(_0x28659b[_0x91f555(0x105)]=!0x0),(_0x470e69[_0x91f555(0xd1)][_0x91f555(0x1ac)]>_0x13b741['global'][_0x91f555(0x11f)]||_0x470e69['hits'][_0x91f555(0x145)]>_0x13b741[_0x91f555(0x1c3)][_0x91f555(0x138)])&&(_0x470e69['hits'][_0x91f555(0x105)]=!0x0);}}catch{}}}return _0x853c2d;}function G(_0x7dac70){var _0x4fb4c4=_0x34ea16;if(_0x7dac70&&typeof _0x7dac70=='object'&&_0x7dac70[_0x4fb4c4(0x118)])switch(_0x7dac70[_0x4fb4c4(0x118)][_0x4fb4c4(0xc8)]){case _0x4fb4c4(0x14a):return _0x7dac70['hasOwnProperty'](Symbol[_0x4fb4c4(0x19c)])?Promise[_0x4fb4c4(0xfc)]():_0x7dac70;case _0x4fb4c4(0x160):return Promise[_0x4fb4c4(0xfc)]();}return _0x7dac70;}((_0x749b89,_0x2827b8,_0x580b99,_0x418fc9,_0x44c2a9,_0x23ed43,_0x1b9ef6,_0x24f371,_0x5d1b5f,_0x70341a,_0x561d12,_0x5c054b)=>{var _0x25b334=_0x34ea16;if(_0x749b89[_0x25b334(0x1a4)])return _0x749b89[_0x25b334(0x1a4)];let _0x294980={'consoleLog':()=>{},'consoleTrace':()=>{},'consoleTime':()=>{},'consoleTimeEnd':()=>{},'autoLog':()=>{},'autoLogMany':()=>{},'autoTraceMany':()=>{},'coverage':()=>{},'autoTrace':()=>{},'autoTime':()=>{},'autoTimeEnd':()=>{}};if(!X(_0x749b89,_0x24f371,_0x44c2a9))return _0x749b89[_0x25b334(0x1a4)]=_0x294980,_0x749b89[_0x25b334(0x1a4)];let _0x4ac171=b(_0x749b89),_0x44ae90=_0x4ac171['elapsed'],_0x281c3c=_0x4ac171['timeStamp'],_0x156600=_0x4ac171['now'],_0x564ce7={'hits':{},'ts':{}},_0x20d77e=J(_0x749b89,_0x5d1b5f,_0x564ce7,_0x23ed43,_0x5c054b,_0x44c2a9===_0x25b334(0x114)?G:void 0x0),_0x1583f6=(_0x138848,_0x4e327a,_0x410ab7,_0x1afae4,_0xf58f6a,_0x49dcce)=>{var _0x41f612=_0x25b334;let _0x224524=_0x749b89[_0x41f612(0x1a4)];try{return _0x749b89[_0x41f612(0x1a4)]=_0x294980,_0x20d77e(_0x138848,_0x4e327a,_0x410ab7,_0x1afae4,_0xf58f6a,_0x49dcce);}finally{_0x749b89[_0x41f612(0x1a4)]=_0x224524;}},_0x3178b9=_0x202de7=>{_0x564ce7['ts'][_0x202de7]=_0x281c3c();},_0x13cc1b=(_0x1c13ca,_0x42a326)=>{var _0x3ed0b6=_0x25b334;let _0x4c546f=_0x564ce7['ts'][_0x42a326];if(delete _0x564ce7['ts'][_0x42a326],_0x4c546f){let _0x4f11ca=_0x44ae90(_0x4c546f,_0x281c3c());_0xe67207(_0x1583f6(_0x3ed0b6(0x145),_0x1c13ca,_0x156600(),_0x468b04,[_0x4f11ca],_0x42a326));}},_0x53c802=_0x4eb69a=>{var _0x3b77b5=_0x25b334,_0x408cd3;return _0x44c2a9===_0x3b77b5(0x114)&&_0x749b89[_0x3b77b5(0x188)]&&((_0x408cd3=_0x4eb69a==null?void 0x0:_0x4eb69a[_0x3b77b5(0x129)])==null?void 0x0:_0x408cd3['length'])&&(_0x4eb69a['args'][0x0][_0x3b77b5(0x188)]=_0x749b89[_0x3b77b5(0x188)]),_0x4eb69a;};_0x749b89[_0x25b334(0x1a4)]={'consoleLog':(_0x27f701,_0x2ce433)=>{var _0x1a8f8a=_0x25b334;_0x749b89['console']['log'][_0x1a8f8a(0xc8)]!=='disabledLog'&&_0xe67207(_0x1583f6(_0x1a8f8a(0x172),_0x27f701,_0x156600(),_0x468b04,_0x2ce433));},'consoleTrace':(_0x9d0f76,_0x963e49)=>{var _0xbd38e=_0x25b334,_0x291f9e,_0x22bd5e;_0x749b89[_0xbd38e(0xea)][_0xbd38e(0x172)]['name']!==_0xbd38e(0x161)&&((_0x22bd5e=(_0x291f9e=_0x749b89['process'])==null?void 0x0:_0x291f9e['versions'])!=null&&_0x22bd5e['node']&&(_0x749b89[_0xbd38e(0x11a)]=!0x0),_0xe67207(_0x53c802(_0x1583f6('trace',_0x9d0f76,_0x156600(),_0x468b04,_0x963e49))));},'consoleError':(_0x12a0af,_0x39f06f)=>{var _0x3ec0a4=_0x25b334;_0x749b89[_0x3ec0a4(0x11a)]=!0x0,_0xe67207(_0x53c802(_0x1583f6('error',_0x12a0af,_0x156600(),_0x468b04,_0x39f06f)));},'consoleTime':_0x3f0828=>{_0x3178b9(_0x3f0828);},'consoleTimeEnd':(_0x1a4f7e,_0x345701)=>{_0x13cc1b(_0x345701,_0x1a4f7e);},'autoLog':(_0x52f6fa,_0x1cedc2)=>{var _0x418819=_0x25b334;_0xe67207(_0x1583f6(_0x418819(0x172),_0x1cedc2,_0x156600(),_0x468b04,[_0x52f6fa]));},'autoLogMany':(_0x6057b7,_0x1b7e26)=>{var _0x49b88c=_0x25b334;_0xe67207(_0x1583f6(_0x49b88c(0x172),_0x6057b7,_0x156600(),_0x468b04,_0x1b7e26));},'autoTrace':(_0x4b61cf,_0x2766f3)=>{_0xe67207(_0x53c802(_0x1583f6('trace',_0x2766f3,_0x156600(),_0x468b04,[_0x4b61cf])));},'autoTraceMany':(_0x3e5181,_0x16f50e)=>{var _0x286dd8=_0x25b334;_0xe67207(_0x53c802(_0x1583f6(_0x286dd8(0x182),_0x3e5181,_0x156600(),_0x468b04,_0x16f50e)));},'autoTime':(_0x2c4b10,_0x4be44a,_0x2ba611)=>{_0x3178b9(_0x2ba611);},'autoTimeEnd':(_0x5e03ff,_0x5980db,_0x317c23)=>{_0x13cc1b(_0x5980db,_0x317c23);},'coverage':_0x5a8518=>{var _0x3f417c=_0x25b334;_0xe67207({'method':_0x3f417c(0x1c1),'version':_0x23ed43,'args':[{'id':_0x5a8518}]});}};let _0xe67207=H(_0x749b89,_0x2827b8,_0x580b99,_0x418fc9,_0x44c2a9,_0x70341a,_0x561d12),_0x468b04=_0x749b89['_console_ninja_session'];return _0x749b89['_console_ninja'];})(globalThis,_0x34ea16(0xe7),_0x34ea16(0x12c),_0x34ea16(0x133),_0x34ea16(0xe5),'1.0.0',_0x34ea16(0x18e),_0x34ea16(0x1ba),_0x34ea16(0x17f),_0x34ea16(0xd6),'1',{\"resolveGetters\":false,\"defaultLimits\":{\"props\":100,\"elements\":100,\"strLength\":51200,\"totalStrLength\":51200,\"autoExpandLimit\":5000,\"autoExpandMaxDepth\":10},\"reducedLimits\":{\"props\":5,\"elements\":5,\"strLength\":256,\"totalStrLength\":768,\"autoExpandLimit\":30,\"autoExpandMaxDepth\":2},\"reducePolicy\":{\"perLogpoint\":{\"reduceOnCount\":50,\"reduceOnAccumulatedProcessingTimeMs\":100,\"resetWhenQuietMs\":500,\"resetOnProcessingTimeAverageMs\":100},\"global\":{\"reduceOnCount\":1000,\"reduceOnAccumulatedProcessingTimeMs\":300,\"resetWhenQuietMs\":50,\"resetOnProcessingTimeAverageMs\":100}}});");}catch(e){}};/* istanbul ignore next */function oo_oo(/**@type{any}**/i,/**@type{any}**/...v){try{oo_cm().consoleLog(i, v);}catch(e){} return v};/* istanbul ignore next */function oo_tr(/**@type{any}**/i,/**@type{any}**/...v){try{oo_cm().consoleTrace(i, v);}catch(e){} return v};/* istanbul ignore next */function oo_tx(/**@type{any}**/i,/**@type{any}**/...v){try{oo_cm().consoleError(i, v);}catch(e){} return v};/* istanbul ignore next */function oo_ts(/**@type{any}**/v){try{oo_cm().consoleTime(v);}catch(e){} return v;};/* istanbul ignore next */function oo_te(/**@type{any}**/v, /**@type{any}**/i){try{oo_cm().consoleTimeEnd(v, i);}catch(e){} return v;};/*eslint unicorn/no-abusive-eslint-disable:,eslint-comments/disable-enable-pair:,eslint-comments/no-unlimited-disable:,eslint-comments/no-aggregating-enable:,eslint-comments/no-duplicate-disable:,eslint-comments/no-unused-disable:,eslint-comments/no-unused-enable:,*/